var numberOfImagesToLoad;
var currentElement;
var moveItemInterval;
var mouseDownTimeout;
var selected_color;
var selected_grip;
var selected_shelf;
var selected_linksku;
var isButtonPressed = false;
var isMovingItem = false;
var destinationSelector = '#main.configure .container';
var itemSelector = '#main.configure .container .item';
var allItemsContainmentStarted = false;
/*
var previewGalleryConfiguration = {
	slidesToScroll: 1,
	prevArrow: '<button class="slick-prev">Previous</button>',
	nextArrow: '<button class="slick-next">Next</button>',
	adaptiveHeight: true,
	infinite: false
};
 */
var isTouchDevice = 'ontouchstart' in document.documentElement;
var timeoutFunctionId;
var nbrRatio;
var nbrRescaleRatio;
var selected_option = '';

jQuery(document).ready(function() {
    init_accordion();
    //init_slick_carousel();

	jQuery(document).on('click touchstart', function(event) {
		if (!jQuery('#header .setttings-container ul ul').is(":hidden") && !jQuery(event.target).closest('#header .settings-container ul').length) {
			jQuery('#header .settings-container ul ul').slideUp(); 
		}
	});

	jQuery('#header .settings-container > ul > li').on('click touch', function(event) {
		event.preventDefault();
		if (isTouchDevice) {
			jQuery('#header .settings-container ul ul').slideToggle();
		}
	});

	jQuery('#header .settings-container > ul > li').hover(function() {
		jQuery('#header .settings-container ul ul').stop().slideToggle(); 	
	});

	jQuery('#select_language').on('change', function() {
        location.href = '?l=' + jQuery(this).val();
	});


	jQuery('.c-off-canvas--nav a.my-quotations, .c-account a.my-quotations').on('click touch', function(event) {
		event.preventDefault();
		location.href = '/quotations.html';
	});

    jQuery('.c-off-canvas--nav a.my-orders, .c-account a.my-orders').on('click touch', function(event) {
        event.preventDefault();
        location.href = '/orders.html';
    });

    jQuery('.c-off-canvas--nav a.my-forwardorders, .c-account a.my-forwardorders').on('click touch', function(event) {
        event.preventDefault();
        location.href = '/forwardorders.html';
    });

    jQuery('.c-off-canvas--nav a.my-favourites, .c-account a.my-favourites').on('click touch', function(event) {
		event.preventDefault();
		//location.href = '?l=' + jQuery(this).data('language');
	});

	jQuery('.c-off-canvas--nav a.add-user, .c-account a.add-user').on('click touch', function(event) {
		event.preventDefault();
		location.href = '/adduser.html';
	});
	
	jQuery('.c-off-canvas--nav a.settings, .c-account a.settings').on('click touch', function(event) {
		event.preventDefault();
		location.href = '/settings.html';
	});

	// login page

	if (jQuery('#form-validate').length) {
        jQuery.validator.setDefaults({ ignore: ":hidden:not(select:not(:disabled))"});
		jQuery('#form-validate').validate({
			//onfocusout: false,
			onkeyup: false,
			//onclick: false,
			errorElement: 'div',
			errorClass: 'form_error',
			/*
			invalidHandler: function(form, validator) {
				var errors = validator.numberOfInvalids();
				if (errors) {
					var message = (errors == 1 ? 'Gelieve %d veld te corrigeren.' : 'Gelieve %d velden te corrigeren.');
					//jQueryAlert(message.replace(/%d/, errors), 'Fout');
				}
			},
			*/
			errorPlacement: function(error, element) {
				if (jQuery(element).is('input[type=checkbox]')) {
                    error.insertAfter(element.closest('div'))
                } else if (jQuery(element).is('select') && jQuery('#' + jQuery(element).attr('id') + '_chosen').length) {
					error.insertAfter(jQuery('#' + jQuery(element).attr('id') + '_chosen'));
                } else if (jQuery(element).is('select') && jQuery(element).hasClass('autocomplete-combobox')) {
                    error.insertAfter(jQuery(element).next('.custom-combobox'));
				} else {
					error.insertAfter(element);
				}
			},
			highlight: function(element, errorclass) {
				if (jQuery(element).is('input[type=checkbox]')) {
					jQuery('label[for=' + jQuery(element).prop('id') + ']').addClass(errorclass);
				} else {
					jQuery(element).addClass(errorclass);
				}
			},
			unhighlight: function(element, errorclass) {
				if (jQuery(element).is('input[type=checkbox]')) {
					jQuery('label[for=' + jQuery(element).prop('id') + ']').removeClass(errorclass);
				} else {
					jQuery(element).removeClass(errorclass);
				}
			},
			submitHandler: function(form) {
                if (typeof blnRecaptchaAccountRegistration === 'boolean' && blnRecaptchaAccountRegistration) {
                    grecaptcha.execute(widgetIDAccountRegistration);
                } else {
                    submit_form_validate_form(form);
                }
			}
		});
	}
	
	// user type select page
	
	jQuery('#main.usertype .js-selectUserType a').on('click', function(event) {
		event.preventDefault();
        event.stopPropagation();
        window.dataLayer.push({'event': 'click_configurate_now'});
		jQuery('form.form-usertype').find('input#usertype').val(jQuery(this).data('type'));
		jQuery('form.form-usertype').submit()
		
	});

	// select page
	
	/*
    jQuery('#main.select .js-openStyle').on('click touch', function(event) {
		event.preventDefault();
        var objTrigger = jQuery(this);
        var objModal = jQuery('.js-selectStyle');

        var objSelect = objModal.find('select#width');
        objSelect.find('option').remove().end();
        for (var i = nbrMaxWallWidth; i >= objTrigger.data('width'); i = i - 5) {
            objSelect.append('<option value="' + i + '">' + i + ' cm</option>');
        }
        objSelect.val(objTrigger.data('width'));
        objModal.find('input#type').val(objTrigger.data('type'));
        objModal.find('.c-modal__image').attr('src', objTrigger.find('img').attr('src'));

        MicroModal.show('modal-style');
	});
	
	jQuery('.js-selectStyle a').on('click touch', function(event) {
		event.preventDefault();

		var formData = jQuery(this).closest('.form').serialize();
		
		jQuery.ajax({
			url: '/includes/submit_form.php',
			type: 'POST',
			data: formData,
			dataType: 'json',
			cache: false,
			success: function(data) {
				if (data.status) {
					location.href = '/configure.html';
				} else {
					if (data.showLogin != null && data.showLogin) {
						location.href = '/';
					} 
				}
			}
		});
	});
	 */

    jQuery('#main.select .js-openStyle').on('click touch', function(event) {
        event.preventDefault();

        var form = jQuery("#main.select .js-formOpenStyle");
        form.find('#type').val(jQuery(this).data('type'));

        var formData = form.serialize();

        jQuery.ajax({
            url: '/includes/submit_form.php',
            type: 'POST',
            data: formData,
            dataType: 'json',
            cache: false,
            success: function(data) {
                if (data.status) {
                    location.href = '/configure.html';
                } else {
                    if (data.showLogin != null && data.showLogin) {
                        location.href = '/';
                    }
                }
            }
        });
    });

    if (sessionStorage.getItem('selectedFilters')) {
        var selectedFilters = sessionStorage.getItem('selectedFilters').split(',');

        jQuery.each(selectedFilters, function (key, val) {
            jQuery('.c-off-canvas--filter .v-accordion__item input[value="' + val + '"]').prop('checked', true);
        });

        jQuery('.js-filterCount').html(selectedFilters.length);
    }

    var blnAccordionOpen = false;

    jQuery('.c-off-canvas--filter .v-accordion__item').each(function(i, el) {
        var _this = jQuery(el);
        var selected = jQuery(this).find('.js-tag:checked');
        if (selected.length) {
            _this.find('.js-tagGroupCount').html('(' + selected.length + ')');
            if (!blnAccordionOpen) {
                _this.find('.v-accordion__item--trigger').click();
                setTimeout(function() {
                    _this.find('.v-accordion__content').css({ 'height': 'auto' });
                }, 350);
                blnAccordionOpen = true;
            }
        } else {
            _this.find('.js-tagGroupCount').html('');
        }

        _this.find('.js-tag').on('click', function() {
            var count = parseInt(_this.find('.js-tagGroupCount').html().replace(/[^\d]/,'')) || 0;
            if (jQuery(this).is(':checked')) {
                count++;
            } else {
                count--;
            }
            _this.find('.js-tagGroupCount').html((count > 0 ? '(' + count + ')' : ''));
            filter_styles(false);
        });
    });

    if (jQuery('.c-off-canvas--filter').length) {
        filter_styles(true);
    }

    jQuery('.btn-filter-reset').on('click', function() {
        jQuery('.js-filterCount').html('0');
        jQuery('.js-openStyle').show();
		animateGrid();
        jQuery('.js-tag').prop('checked', false);
        jQuery('.js-filterClose').click();
        jQuery('.js-tagGroupCount').html('');
        sessionStorage.removeItem('selectedFilters');
    });

    // configure page

    // Initially hide the configurator wall
    jQuery('.c-editor__configurator .wall, .c-editor__configurator .configurator-wall-width').hide();

    // Further initialisation is done on window.load

	jQuery(document).on('keydown', function(event) {
		var pressedKey = event.which;
		if (currentElement != null && jQuery.inArray(pressedKey, [ 37, 38, 39, 40, 46 ]) != -1) {
			event.preventDefault();
			
			isButtonPressed = true;
			
			if (pressedKey == 37) { // left
				//move_item(jQuery('#main.configure .arrows-container .arrow-left'));
				move_item('left');
			} else if (pressedKey == 39) { // right
				//move_item(jQuery('#main.configure .arrows-container .arrow-right'));
				move_item('right');
			} else if (pressedKey == 38) { // up
				//move_item(jQuery('#main.configure .arrows-container .arrow-top'));
				move_item('up');
			} else if (pressedKey == 40) { // down
				//move_item(jQuery('#main.configure .arrows-container .arrow-bottom'));
				move_item('down');
			} else if (pressedKey == 46) { //delete
				remove_item();
			}
		}
	}).on('keyup', function(event) {
		if (currentElement != null) {
			event.preventDefault();
			isButtonPressed = false;
		}
	});

	/*
	jQuery('#main.configure .arrows-container .arrow').on('click', function(event) {
		event.preventDefault();
	});
	
	jQuery('#main.configure .arrows-container .arrow').on('mousedown touchstart', function(event) {
		event.preventDefault();
		if (currentElement != null) {
			isButtonPressed = true;

			var _this = jQuery(this);
			move_item(_this);
	
			mouseDownTimeout = window.setTimeout(function() {
				moveItemInterval = window.setInterval(function() { 
					move_item(_this.data('direction')); 
				}, 20);
			}, 200);
		}
	}).on('mouseup mouseout touchend touchcancel touchleave', function(event) {
		event.preventDefault();
		isButtonPressed = false;

		window.clearInterval(moveItemInterval);
		window.clearTimeout(mouseDownTimeout);
		
		return true;
	});
	*/
	
	jQuery('#main.configure #kinds').on('change', function() {
		//update_element_selector(jQuery(this).val());
	});

	jQuery('#main.configure .bottom-block .link-holder .remove').on('click touch', function(event) {
		event.preventDefault();
		remove_item();
	});

	jQuery('#main.configure .bottom-block .link-holder .duplicate').on('click touch', function(event) {
		event.preventDefault();
		duplicate_item();
	});

	jQuery('#main.configure .c-editor__menu .c-editor__products .c-editor__product').on('click touch', function(event) {
		event.preventDefault();
		add_item(this);
	});

	jQuery('#main.configure .c-editor__menu #sku').autocomplete({
		source: "/includes/find_sku.php",
		minLength: 2,
		select: function(event, ui) {
			jQuery(this).val(ui.item.value);
		}
	});
	
	jQuery('#main.configure  .c-editor__menu .add-icon').on('click touch', function(event) {
		event.preventDefault();
		var e = jQuery.Event('keyup');
		e.which = 13;
		jQuery('#main.configure .c-editor__menu #sku').trigger(e);
	});

	jQuery('#main.configure  .c-editor__menu #sku').on('keyup', function(event) {
		var pressedKey = event.which;
		if (pressedKey == 13) {
			if (jQuery(this).val().trim() != "") {
				var _this = jQuery(this); 
				jQuery.ajax({
					url: '/includes/get_element_from_sku.php',
					type: 'POST',
					data: {
						sku: _this.val(),
						nbrRatio: nbrRatio
					},
					dataType: 'json',
					cache: false,
					success: function(data) {
						if (data.status) {
							add_item(null, data.element);
							_this.val('');
							//jQuery('#main.configure .slideshow-aside .holder .element_selector #sku').autocomplete('close');
						} else {
							if (data.message != null) jQueryAlert(data.message, data.title);
						}
					}
				});
			}
		}
	});
	
	jQuery('#main.configure .popup-content .close,#main.configure .popup-content .js-mmenu-close').on('click touch', function (event) {
		event.preventDefault();
		jQuery('.popup-content').hide();
        jQuery('.c-editor__menu .mm-ocd').show();

        jQuery(itemSelector).each(function() {
			if (jQuery(this).hasClass('border')) {
				jQuery(this).removeClass('border');
			}
		});
		currentElement = null;
	});

	jQuery('#main.configure .popup-content .element-type:not(.element-extra)').on('click', '.c-editor__option-img', function(event) {
        var item = jQuery(this);
        item.data('width', Math.round(item.data('original-width') * nbrRatio));
        item.data('height', Math.round(item.data('original-height') * nbrRatio));

        jQuery(this).siblings().removeClass('c-editor__option-img--active');
        jQuery(this).addClass('c-editor__option-img--active');
        var img = currentElement.find('img.element');

        var data = {};
        jQuery.each(item.data(), function(key, value) {
            if (key.substring(0, 9) !== 'uiTooltip') {
                data[key] = value;
            }
        });

        //retrieve the rescaled image and update the img src
        get_image(data, img);

        img.one('load', function() {
            img.data('id', item.data('id')).attr('data-id', item.data('id'));
            img.data('group', item.data('group')).attr('data-group', item.data('group'));
            if (parseInt(item.data('width')) > 0) {
                img.data('width', item.data('width')).attr('width', item.data('width')).width(item.data('width'));
            }

            if (parseInt(item.data('height')) > 0) {
                img.data('height', item.data('height')).attr('height', item.data('height')).height(item.data('height'));
            }
            show_element_attributes(img);

            get_element_options();

            var containment = calculate_item_containment(currentElement, currentElement.data('position'));
            currentElement.data('containment', containment);

            reposition_item();

            make_item_draggable(currentElement);

            calculate_configuration_dimensions();

            img = null;
            item = null;
        });

        selected_option = '';
	});
	
	jQuery('#main.configure .form.form-options').isolatedScroll();

    jQuery('#main.configure .btn-measurements').on('click touch', function(event) {
        event.preventDefault();

        var _this = jQuery(this);
        _this.toggleClass('is-active');
        jQuery('.js-configuration-measurements').toggleClass('measurements-visible');

        if (_this.hasClass('is-active')) {
            sessionStorage.removeItem('configuration_measurements_hidden');
        } else {
            sessionStorage.setItem('configuration_measurements_hidden', 1);
        }
    });

    jQuery('#main.configure .btn-show-3d').on('click touch', function(event) {
        event.preventDefault();

        document.getElementById("3d-loader").style.display = "flex";

        jQuery('#canvas-3d').html('');

        var elementsJson = get_elements_json();
        sessionStorage.setItem('3dConfiguration', JSON.stringify(elementsJson));

        MicroModal.show('modal-show3d', {
            onClose: function() {
                if(window.threeDRender)
                {
                    window.threeDRender.destroyScene();
                    delete window.threeDRender;
                }
            },
            closeTrigger: 'modal-close',
            openClass: 'c-modal--open',
            disableScroll: true,
            disableFocus: true,
            awaitOpenAnimation: false,
            awaitCloseAnimation: true,
        });

        window.setTimeout(function() {
            window.threeDRender = new ThreeDMain();
        }, 300);
    });

    jQuery('#main.configure .btn-show-3d-object').on('click touch', function(event) {
        event.preventDefault();
        var elementsJson = get_elements_json();
        jQueryAlert('<pre>' + JSON.stringify(elementsJson, format_elements_json, "\t") + '</pre>', 'Configuration JSON object');
    });

    function json_beautifier(key, value) {

    }
    jQuery('#main.configure .btn-delete').on('click touch', function(event) {
        event.preventDefault();
        if (jQueryConfirm(this, strDeleteConfigurationConfirm, strConfirm, strYes, strNo)) {
            jQuery(itemSelector).remove();
            update_configurator_count(0);
            jQuery('#main.configure .popup-content .close').click();

            calculate_configuration_dimensions();
        }
	});
	
	jQuery('#main.configure .btn-save').on('click touch', function(event) {
		event.preventDefault();
        var elements = [];
        jQuery(itemSelector).each(function () {
            jQuery(this).removeClass('border');
            var elementPosition = jQuery(this).position();
            var img = jQuery(this).find('img.element');
            var element = {};
            element.id = img.data('id');
            element.top = elementPosition.top;
            element.left = elementPosition.left;
            element.position = jQuery(this).data('position');
            element.selected_color = img.data('selected_color');
            element.selected_grip = img.data('selected_grip');
            element.selected_shelf = img.data('selected_shelf');
            element.selected_linksku = img.data('selected_linksku');
            if (typeof img.data('selected_customwidth') !== 'undefined') {
                element.selected_customwidth = img.data('selected_customwidth');
            }
            if (typeof img.data('selected_position_wk_1') !== 'undefined') {
                element.selected_position_wk_1 = img.data('selected_position_wk_1');
            }
            if (typeof img.data('selected_position_wk_2') !== 'undefined') {
                element.selected_position_wk_2 = img.data('selected_position_wk_2');
            }
            element.on_floor = (elementPosition.top + jQuery(this).outerHeight() >= jQuery(destinationSelector).height() ? 1 : 0);

            elements.push(element);
        });

        var configuration = jQuery(destinationSelector).clone();
        configuration.css({'top': 0, 'left': 0});

        html2canvas(jQuery('.container')[0], {
            backgroundColor: null
        }).then(canvas => {
            // Convert as image
            var imageData = Canvas2Image.convertToPNG(canvas);

            var formData = {
                'step': 'configure',
                'elements': elements,
                'configuration': configuration.prop('outerHTML'),
                'imageData': imageData.src.replace(/^data:image\/\w+;base64,/i, ''),
                'configurator_width': jQuery('.img-holder').width()
            }

            jQuery.ajax({
                url: '/includes/submit_form.php',
                type: 'POST',
                data: formData,
                dataType: 'json',
                cache: false,
                success: function (data) {
                    if (data.status) {
                        post_to_api(data);

                        if (data.redirect != null) window.setTimeout(function () {
                            location.href = data.redirect;
                        }, 1000);
                    } else {
                        if (data.showLogin != null && data.showLogin) {
                            location.href = '/';
                        } else {
                            if (data.message != null) jQueryAlert(data.message, data.title);
                        }
                    }
                }
            });
        });
	});

    jQuery('#main.configure .js-changeWallWidth').on('click touch', function(event) {
        event.preventDefault();
        var objTrigger = jQuery(this);
        var objModal = jQuery('.js-configuratorWallWidth');
        var nbrMinWidth = jQuery('.js-configuration-width .measurement').text();
        nbrMinWidth = Math.max(nbrMinWidth, Math.floor(nbrMinWidth / 10) * 10);

        var objSelect = objModal.find('select#width');
        objSelect.find('option').remove().end();
        for (var i = nbrMaxWallWidth; i >= nbrMinWidth; i = i - 5) {
            objSelect.append('<option value="' + i + '">' + i + ' cm</option>');
        }
        objSelect.val(parseInt(jQuery('.js-wallWidth').text()));

        MicroModal.show('modal-configuratorWallWidth');
    });

    jQuery('#main.configure .js-configuratorWallWidth a').on('click touch', function(event) {
        event.preventDefault();

        var nbrNewConfiguratorWidth = jQuery('.js-configuratorWallWidth select').val();  // width in cm

        jQuery.ajax({
            url: '/includes/submit_form.php',
            method: 'POST',
            data: {
                step: 'change_configurator_width',
                width: nbrNewConfiguratorWidth
            },
            success: function(data) {
                var nbrOldConfiguratorWidth = data.currentWidth;   // width in cm

                var nbrOldWallWidth = jQuery('.wall').width();  // width in px
                var nbrNewWallWidth = Math.ceil(nbrOldWallWidth / nbrOldConfiguratorWidth * nbrNewConfiguratorWidth);  // width in px

                // calculate left position of leftmost element and total width of the configuration in px
                var nbrMinLeft = nbrOldWallWidth;
                var nbrTotalWidth = 0;

                jQuery(itemSelector).each(function(index, element) {
                    var $element = jQuery(element);
                    var nbrElementLeft = $element.position().left;
                    nbrMinLeft = Math.min(nbrMinLeft, nbrElementLeft);
                    nbrTotalWidth = Math.max(nbrTotalWidth, nbrElementLeft + $element.outerWidth());
                });

                // calculate new left position for the configuration in px, so that the configuration is centered in the new wall width
                // (difference between wall width and total configuration width corrected with position of leftmost element)
                var nbrLeft = Math.round((nbrNewWallWidth - (nbrTotalWidth - nbrMinLeft)) / 2);

                // update each elements left position
                // we correct the elements left position with the left position of the leftmost element,
                // this way we initially put the configuration at the left of the wall, then we add the new left position
                // this results in a centered configuration on the new wall width
                jQuery(itemSelector).each(function(index, element) {
                    var $element = jQuery(element);
                    $element.css({'left': $element.position().left - nbrMinLeft + nbrLeft });
                });

                jQuery('.wall, .container').width(nbrNewWallWidth);

                jQuery('.js-wallWidth').text(nbrNewConfiguratorWidth);

                set_all_items_containment();

                calculate_configuration_dimensions();

                MicroModal.close('modal-configuratorWallWidth');
            }
        })
    });

    // order page

	if (jQuery('#main.order').length) {
        /*
        if (jQuery('#modal-show-prices').length) {
            MicroModal.show('modal-show-prices', {
                openTrigger: 'modal-open',
                closeTrigger: 'modal-close',
                openClass: 'c-modal--open',
                disableScroll: true,
                disableFocus: true,
                awaitOpenAnimation: false,
                awaitCloseAnimation: true,
            });
        }
        */

		jQuery('.btn-print').on('click touch', function(event) {
			event.preventDefault();
            window.dataLayer.push({'event': 'print_configuration'});
            var imgTop = jQuery('<img>');
            imgTop.attr('src', jQuery('.c-overview__configuration-pdf-print .c-overview__configuration--top').data('img'));
            imgTop.on('load', function() {
                var imgBottom = jQuery('<img>');
                imgBottom.attr('src', jQuery('.c-overview__configuration-pdf-print .c-overview__configuration--bottom').data('img'));
                imgBottom.on('load',function() {
                    window.print();
                });
            });
		});

        jQuery('.js-find-dealer').on('click', function() {
            window.dataLayer.push({'event': 'search_dealer'});
        });

        jQuery('#main.order .result-table-section.quotation select').on('change', function() {
            jQuery(this).valid();
        });

        jQuery('.btn-copy-configuration-link').on('click touch', function(event) {
            event.preventDefault();
            window.dataLayer.push({'event': 'copy_configuration_link'});
            copyToClipboard('configuration-link');
            jQueryAlert(strCopyConfigurationLinkMessage, strCopyConfigurationLinkTitle);
        });

		jQuery('.btn-pdf, .btn-pdf-image').on('click touch', function(event) {
			event.preventDefault();
            window.dataLayer.push({'event': 'download_configuration'});
			var contents = jQuery('html').clone();
			contents.find('body').addClass('pdf');
			if (jQuery(this).hasClass('btn-pdf-image')) {
				contents.find('body').addClass('pdf-image');
			}
			jQuery.ajax({
				url: '/includes/generate_pdf.php',
				type: 'POST',
				data: {
					'contents': contents.prop('outerHTML'),
					'image-only': jQuery(this).hasClass('btn-pdf-image'),
					'type': jQuery(this).data('type'),
                    'configurationnr': jQuery(this).data('configurationnr'),
				},
				dataType: 'json',
				cache: false,
				success: function(data) {
					if (data.status) {
						location.href = '/includes/download_file.php?filename=' + data.filename + '&downloadname=' + data.downloadname;
					}
					contents = null;
				}
			});
		});

		jQuery('.btn-quotation').on('click touch', function(event) {
			event.preventDefault();
            var blnConfirm = jQuery(this).hasClass('confirm');
            if ((blnConfirm && jQueryConfirm(this, strQuotationConfirmMessage, strQuotationConfirmTitle, strQuotationConfirmYes, strQuotationConfirmNo)) || !blnConfirm) {
                /*
                var quotation = jQuery('#main.order .quotation');
                if (quotation.is(':hidden')) {
                    jQuery("#sets_overlay table tr").remove();

                    var blnAllSet = true;
                    if (jQuery('#main.order tr.set').length) {
                        jQuery('#main.order .set select').each(function () {
                            if (jQuery(this).val() == "") blnAllSet = false;
                        });
                    }

                    if (!blnAllSet) {
                        jQuery('#main.order tr.set').each(function () {
                            jQuery('#sets_overlay table').append(jQuery(this).clone());
                        });

                        jQuery('#main.order .set select').each(function () {
                            jQuery('#sets_overlay .set select[name="' + jQuery(this).attr('name') + '"]').val(jQuery(this).val());
                        });

                        jQuery('.ui-dialog-buttonset button:first-child').attr('disabled', true).addClass('ui-state-disabled');

                        jQuery('#sets_overlay .set select').on('change', function () {
                            var blnAllSet = true;
                            jQuery('#sets_overlay .set select').each(function () {
                                if (jQuery(this).val() == '') blnAllSet = false;
                            });
                            if (blnAllSet) {
                                jQuery('.ui-dialog-buttonset button:first-child').attr('disabled', false).removeClass('ui-state-disabled');
                            } else {
                                jQuery('.ui-dialog-buttonset button:first-child').attr('disabled', true).addClass('ui-state-disabled');
                            }
                        });

                        jQuery('#sets_overlay').dialog('open');
                        jQuery('#sets_overlay').isolatedScroll();
                        jQuery('#sets_overlay .set select').each(function () {
                            if (jQuery(this).val() == '') {
                                jQuery(this)[0].focus();
                                return false;
                            }
                        });
                    } else {
                        jQuery('#main.order .set select').attr('disabled', true);
                        quotation.show();
                        jQuery('html,body').animate({'scrollTop': quotation.offset().top});
                    }
                } else {
                    quotation.slideUp();
                    jQuery('#main.order .set select').attr('disabled', false);
                }
                */
            } else {
                event.stopImmediatePropagation();
                event.stopPropagation();
            }
		});

		if (jQuery('#sets_overlay').length) {
			jQuery('#sets_overlay').dialog({
				autoOpen: false,
				modal: true,
				height: 600,
				width: 724,
				buttons: {
					'Bewaren': function() {
						jQuery('#sets_overlay .set select').each(function() {
							jQuery('#main.order .set select[name="' + jQuery(this).attr('name') + '"]').val(jQuery(this).val());
						});
						jQuery(this).dialog('close');
						jQuery('#main.order .set select').attr('disabled', true);
						jQuery('#main.order .quotation').show();
						jQuery('html,body').animate({ 'scrollTop': jQuery('#main.order .quotation').offset().top });
					},
					'Annuleren': function() {
						jQuery(this).dialog('close');
					}
				},
				open: function() {
					jQuery('.ui-dialog .ui-dialog-titlebar-close').remove();
				},
				position: {
					my: 'center center',
					at: 'center center',
					of: window
				}
			});
		}

		jQuery('.btn-order').on('click touch', function(event) {
			event.preventDefault();
			if (jQuery(this).hasClass('disabled')) {
				event.stopImmediatePropagation();
                event.stopPropagation();
			}
            /*
			var quotation = jQuery('#main.order .quotation');
			if (quotation.is(':hidden')) {
				quotation.show();
				jQuery('html,body').animate({ 'scrollTop': quotation.offset().top });
			} else {
				quotation.slideUp();
			}
			*/
		});
		
		if (jQuery('.btn-xlsx').length) {
			jQuery('.btn-xlsx').on('click', function(event) {
				event.preventDefault();
				if (jQuery(this).hasClass('disabled')) {
					return false;
				}
	
				/*
				// this code can be used if we want the download without the need to press a cutton in the custom confirm box
				// there's a risk here that te page is reloaded before the download has been sent
				if (jQueryConfirm(jQuery(this), strXLSXMessage, strXLSXTitle, strXLSXYes, strXLSXNo)) {
					// this gets executed when "yes" is clicked in the custom confirm box
					jQuery('#form-validate.order').find('input[name=sendEmail]').val(0);
					jQuery('#form-validate.order').submit();
				} else {
					// this gets executed when the button is clicked
					// download is always sent to the browser
					jQuery.ajax({
						url: '/includes/generate_xlsx.php',
						type: 'POST',
						data: {
							'xlsx': jQuery('#XLSX').val()
						},
						dataType: 'json',
						cache: false,
						success: function(data) {
							if (data.status) {
								location.href = '/includes/download_file.php?filename=' + data.filename + '&downloadname=' + data.downloadname;
							}
						}
					});
				}
				*/
				
				// this code can be used if we only want the download after a button in the custom confirm box was clicked
				// download is sent asynchroneous, so page reload will happen after the download
				
				// create callback function in the global space so that it is available for subsequent calls
				if (typeof window.processXLSX !== 'function') {
					window.processXLSX = function(blnStatus) {
						if (blnStatus) {
							jQuery.ajax({
								url: '/includes/generate_xlsx.php',
								type: 'POST',
								data: {
									'xlsx': jQuery('#XLSX').val() 
								},
								dataType: 'json',
								cache: false,
								success: function(data) {
									if (data.status) {
										location.href = '/includes/download_file.php?filename=' + data.filename + '&downloadname=' + data.downloadname;
										window.setTimeout(function() {
											jQuery('.extra_status img, .extra_status span').addClass('disabled').on('click', function() { return false; });
											jQuery('#form-validate.order').find('input[name=sendEmail]').val(0);
											jQuery('#form-validate.order').find('input[name=system_dealer]').val(1);
											jQuery('#form-validate.order').find('input[name=create_order]').val(jQuery('.btn-xlsx').data('create-order'));
											jQuery('#form-validate.order').find('input[name=success_message]').val(jQuery("#xlsxSuccess").val());
											jQuery('#form-validate.order').submit();
										}, 1500);
									}
								}
							});
						}
					}	
				}
				
				// call custom alert with this callbackfunction
				jQueryConfirmWithCallback('dialog-xlsx', strThirdPartyMessage, strThirdPartyTitle, strThirdPartyYes, strThirdPartyNo, window.processXLSX);
			});
		}
		
		if (jQuery('.btn-galvano').length) {
			jQuery('.btn-galvano').on('click', function(event) {
				event.preventDefault(); 
				if (jQuery(this).hasClass('disabled')) {
					return false;
				}
	
				// this code can be used if we only want the download after a button in the custom confirm box was clicked
				// download is sent asynchroneous, so page reload will happen after the download
				// we don't have a download here	 			
				
				// create callback function in the globals space so that it is available for subsequent calls
				if (typeof window.processGalvano !== 'function') {
					window.processGalvano = function(blnStatus) {
						// when yes is clicked, we send to Galvano and submit the order form
						if (blnStatus) {
							window.open(strGalvanoUrl + jQuery('#galvanoID').val());
							jQuery('#form-validate.order').find('input[name=sendEmail]').val(0);
							jQuery('#form-validate.order').find('input[name=system_dealer]').val(1);
							jQuery('#form-validate.order').find('input[name=create_order]').val(0);
							jQuery('#form-validate.order').find('input[name=success_message]').val(jQuery("#galvanoSuccess").val());
							jQuery('#form-validate.order').submit();
							/*							
							jQuery.ajax({
								url: '/includes/post_to_galvano.php',
								type: 'POST',
								data: {
									'galvanoUrl': strGalvanoUrl,
									'galvanoID': jQuery('#galvanoID').val() 
								},
								dataType: 'json',
								cache: false,
								success: function(data) {
									jQuery('#dialog-galvano').dialog('close');
									if (data.status) {
										jQuery('#form-validate.order').find('input[name=sendEmail]').val(0);
										jQuery('#form-validate.order').find('input[name=system_dealer]').val(1);
										jQuery('#form-validate.order').find('input[name=create_order]').val(0);
										jQuery('#form-validate.order').submit();
									} else {
										jQueryAlert(strPostToThirdPartyFailed, strError);
									}
										
								}
							});
							*/
						}
					}	
				}
	
				// call custom alert with this callbackfunction
				jQueryConfirmWithCallback('dialog-galvano', strThirdPartyMessage, strThirdPartyTitle, strThirdPartyYes, strThirdPartyNo, window.processGalvano);
			});
		}

		if (jQuery('.btn-vanmarcke').length) {
			jQuery('.btn-vanmarcke').on('click', function(event) {
				event.preventDefault(); 
				if (jQuery(this).hasClass('disabled')) {
					return false;
				}
	
				// this code can be used if we only want the download after a button in the custom confirm box was clicked
				// download is sent asynchroneous, so page reload will happen after the download
				// we don't have a download here	 			
				
				// create callback function in the globals space so that it is available for subsequent calls
				if (typeof window.processVanmarcke !== 'function') {
					window.processVanmarcke = function(blnStatus) {
						// when yes is clicked, we send to Galvano and submit the order form
						if (blnStatus) {
							jQuery('#form-validate.order').find('input[name=sendEmail]').val(0);
							jQuery('#form-validate.order').find('input[name=system_dealer]').val(1);
							jQuery('#form-validate.order').find('input[name=success_message]').val(jQuery("#vanmarckeSuccess").val());
							jQuery('#form-validate.order').submit();
						}
					}	
				}
	
				// call custom alert with this callbackfunction
				jQueryConfirmWithCallback('dialog-vanmarcke', strThirdPartyMessage, strThirdPartyTitle, strThirdPartyYes, strThirdPartyNo, window.processVanmarcke);
			});
		}

        /*
		if (jQuery('.btn-visoft3d').length) {
			jQuery('.btn-visoft3d').on('click', function(event) {
				event.preventDefault();
				if (jQuery(this).hasClass('disabled')) {
					return false;
				}

				// this code can be used if we only want the download after a button in the custom confirm box was clicked
				// download is sent asynchroneous, so page reload will happen after the download

				// create callback function in the global space so that it is available for subsequent calls
				if (typeof window.processVisoft3dCSV !== 'function') {
					window.processVisoft3dCSV = function(blnStatus) {
						if (blnStatus) {
							jQuery.ajax({
								url: '/includes/generate_visoft3dcsv.php',
								type: 'POST',
								data: {
									'visoft3dcsv': jQuery('#visoft3dcsv').val()
								},
								dataType: 'json',
								cache: false,
								success: function(data) {
									if (data.status) {
										location.href = '/includes/download_file.php?filename=' + data.filename + '&downloadname=' + data.downloadname;
										window.setTimeout(function() {
											// we disable all buttons, so that they can not be clicked during the reload
											jQuery('.btn-holder .btn').addClass('disabled');
											location.reload();
										}, 1500);
									}
								}
							});
						}
					}
				}

				// call custom alert with this callbackfunction
				//jQueryConfirmWithCallback('dialog-visoft3dcsv', strThirdPartyMessage, strThirdPartyTitle, strThirdPartyYes, strThirdPartyNo, window.processVisoft3dCSV);
                window.processVisoft3dCSV(true);
			});
		}
		*/

        jQuery('.btn-email').on('click', function(event) {
            event.preventDefault();

            window.dataLayer.push({'event': 'click_mail_pop_up'});

            var objTrigger = jQuery(this);
            var objModal = jQuery('#modal-email');

            objModal.find('.form-email').show();
            objModal.find('.email-confirmation').hide();

            MicroModal.show('modal-email');
        });

        jQuery('#dialog-email .close').on('click', function() {
            jQuery('#dialog-email').dialog('destroy');
        })

        if (jQuery('.form-email').length) {
            jQuery('.form-email').validate({
                //onfocusout: false,
                onkeyup: false,
                //onclick: false,
                errorElement: 'div',
                errorClass: 'form_error',
                /*
                invalidHandler: function(form, validator) {
                    var errors = validator.numberOfInvalids();
                    if (errors) {
                        var message = (errors == 1 ? 'Gelieve %d veld te corrigeren.' : 'Gelieve %d velden te corrigeren.');
                        //jQueryAlert(message.replace(/%d/, errors), 'Fout');
                    }
                },
                */
                errorPlacement: function (error, element) {
                    if (jQuery(element).is('input[type=checkbox]')) {
                        error.insertAfter(element.closest('div'))
                    } else if (jQuery(element).is('select') && jQuery('#' + jQuery(element).attr('id') + '_chosen').length) {
                        error.insertAfter(jQuery('#' + jQuery(element).attr('id') + '_chosen'));
                    } else {
                        error.insertAfter(element);
                    }
                },
                highlight: function (element, errorclass) {
                    if (jQuery(element).is('input[type=checkbox]')) {
                        jQuery('label[for=' + jQuery(element).prop('id') + ']').addClass(errorclass);
                    } else {
                        jQuery(element).addClass(errorclass);
                    }
                },
                unhighlight: function (element, errorclass) {
                    if (jQuery(element).is('input[type=checkbox]')) {
                        jQuery('label[for=' + jQuery(element).prop('id') + ']').removeClass(errorclass);
                    } else {
                        jQuery(element).removeClass(errorclass);
                    }
                },
                submitHandler(form) {
                    if (jQuery(form).validate().numberOfInvalids() != 0) {
                        return false;
                    }

                    window.dataLayer.push({'event': 'mail_configuration'})

                    var submitButton = jQuery(form).find('button[type="submit"]');
                    submitButton.attr('disabled', true);

                    var contents = jQuery('html').clone();
                    contents.find('body').addClass('pdf pdf-email');
                    jQuery.ajax({
                        url: '/includes/generate_pdf.php',
                        type: 'POST',
                        data: {
                            'contents': contents.prop('outerHTML'),
                            'image-only': jQuery(this).hasClass('btn-pdf-image'),
                            'type': jQuery('#modal-email input[name=type]').val(),
                            'email': jQuery('#modal-email input[name=email]').val(),
                            'configurationnr': jQuery('#modal-email input[name=configurationnr]').val(),
                        },
                        dataType: 'json',
                        cache: false,
                        success: function (data) {
                            if (data.status) {
                                jQuery('.email-confirmation').show();
                                jQuery('.form-email').hide();
                                //jQuery('#dialog-email .email').val('');
                            }
                            submitButton.attr('disabled', false);
                            contents = null;
                        }
                    });

                }
            });
        }
	}
	
	
	// quotations page
	
	if (jQuery('#main.quotations').length) {
		jQuery('.btn-view-quotation').on('click touch', function(event) {
			event.preventDefault();
			jQuery('input#quotation_ID').val(jQuery(this).data('id')); 
			jQuery('.form-select-quotation').submit();
		});
		
		jQuery('div.search a.js-search').on('click touch', function(event) {
			event.preventDefault();
			jQuery('div.search form').submit();
		});

        jQuery('div.search input').on('search', function() {
            if ('' == this.value) {
                jQuery('div.search form').submit();
            }
        })
        jQuery('div.search select').on('change', function(event) {
            event.preventDefault();
            jQuery('div.search form').submit();
        });
		
	}
	
	if (jQuery('.extra_status').length) {
        jQuery('.extra_status').on('change', function() {
            var _this = jQuery(this);
            var enabled = _this.is(':checked');
			jQuery.ajax({
				url: '/includes/update_order_status.php',
				method: 'POST',
				data: {
					'quotation_ID': jQuery(this).data('quotation-id'),
					'extra_status': (enabled ? jQuery(this).data('status') : '')
				},
				dataType: 'json',
				cache:false,
				success: function(data) {
					if (data.status) {
                        if (enabled) {
                            var toggles = _this.closest('div').siblings().find('input[type=checkbox]');
                            toggles.each(function(i, el) {
                                jQuery(el).attr('checked', false);
                            });
                        }

						jQuery("td#status" + _this.data('quotation-id') + ', span.status').html(data.quotationStatus);
						
						if (jQuery('#main.order').length) {
							if (_this.is(':checked')) {
								var quotation = jQuery('#main.order .quotation');
								quotation.slideUp();
								jQuery('.btn-order').addClass('disabled');					
								jQuery('.btn-xlsx').addClass('disabled');					
								jQuery('.btn-galvano').addClass('disabled');					
								jQuery('.btn-vanmarcke').addClass('disabled');					
							} else {
								jQuery('.btn-order').removeClass('disabled');					
								jQuery('.btn-xlsx').removeClass('disabled');					
								jQuery('.btn-galvano').removeClass('disabled');					
								jQuery('.btn-vanmarcke').removeClass('disabled');					
							}
						}
					}
				}
			});
			
		});
    }

	jQuery(window).on('resize orientationchange', function() {
		if (jQuery('#main.configure').length) {
            clearTimeout(timeoutFunctionId);
            jQuery('.slideshow-section').hide();
            timeoutFunctionId = setTimeout(function() {
                jQuery('.slideshow-section').show();
                rescale_all();
                if (!allItemsContainmentStarted) {
                    allItemsContainmentStarted = true;
                    window.setTimeout(set_all_items_containment, 500);
                }
            }, 500);
		}

	});
	
	jQuery('.ui-dialog button').addClass('btn');

	// don't show contextmenu on touch devices
	if (is_touch_device()) {
		jQuery(document).on('contextmenu', function(event) {
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
			return false;
		});
	}

	// activate chosen
    jQuery('#main.configure select:not(:hidden)').chosen();

    if (jQuery('.result-table-section.quotation').length) {
        var chosen_select = jQuery('.result-table-section.quotation').find('select');
        jQuery('.result-table-section.quotation').show();
        chosen_select.chosen({
            //disable_search: true
            //width: chosen_select.width() + 20
        });
        jQuery('.result-table-section.quotation').hide();
    }

    jQuery('.js-showHidePassword').on('click', function() {
        var field = jQuery(this).parent('div').find('input');
        var hide = jQuery(this).find('.hide');
        var show = jQuery(this).find('.show');
        if (field.prop('type') === 'password') {
            field.prop('type', 'text');
            show.hide();
            hide.show();
        } else {
            field.prop('type', 'password');
            show.show();
            hide.hide();
        }
    });

    jQuery.ui.autocomplete.prototype._resizeMenu = function () {
        var ul = this.menu.element;
        ul.outerWidth(this.element.outerWidth());
    }

    jQuery('.translation-code-tooltip').tooltip({
        position: {
            my: 'center bottom',
            at: 'center top+5'
        }

    });

});

function submit_form_validate_form(form) {
    if (jQuery(form).validate().numberOfInvalids() != 0) {
        return false;
    }

    var submitButton = jQuery(form).find('button[type="submit"]');
    submitButton.attr('disabled', true);

    if (jQuery('#main.order .set select').length) {
        var sets = {};
        jQuery('#main.order .set select').each(function() {
            var value = jQuery(this).val();
            var key = jQuery(this).attr('name').match(/\[(\d+)]/)[1];
            sets[key] = value;
        });
        jQuery('input#sets').val(JSON.stringify(sets));
    }

    var formData = jQuery(form).serializeArray();

    var formType = jQuery(form).find('input[type=hidden][name=step]').val();

    if (jQuery.inArray(formType, [ 'quotation', 'order' ]) != -1) {
        var contents = jQuery('html').clone();
        contents.find('body').addClass('pdf');

        var comments = jQuery(form).find('#comments');
        if (comments.val() != '') {
            contents.find('.result-table-section.comments div div').html(comments.val().replace(/(\r\n|\n\r|\r|\n)/g, '<br>'));
            contents.find('.result-table-section.comments').show();
        }
        formData.push({ name: 'contents', value: contents.prop('outerHTML')});
    }

    if (formType == 'login') {
        window.dataLayer.push({'event': 'login_account'});
    } else if (formType == 'register') {
        window.dataLayer.push({'event': 'new_account_request'});
    } else if (formType == 'quotation') {
        window.dataLayer.push({'event': 'request_quote'});
    } else if (formType == 'order') {
        window.dataLayer.push({'event': 'request_order'});
    }

    jQuery.ajax({
        url: '/includes/submit_form.php',
        method: 'POST',
        data: formData,
        dataType: 'json',
        cache: false,
        success: function(data) {
            if (!data.status) {
                if (data.showLogin != null && data.showLogin) {
                    location.href = '/';
                    return false;
                } else {
                    submitButton.attr('disabled', false);
                }
            } else {
                if (data.keepData != null && data.keepData) {
                } else {
                    form.reset();
                }

                post_to_api(data);
            }

            if (data.message != null) {
                jQueryAlert(data.message, data.title);
                if (data.redirect != null) {
                    jQuery('#modal-alert .c-modal__button-ok, #modal-alert .c-modal__close').on('click', function() {
                        location.href = data.redirect;
                    });
                } else {
                    submitButton.attr('disabled', false);
                }
            } else if (data.redirect != null) {
                location.href = data.redirect;
            }
        }
    });
}

function filter_styles(blnInit) {
    var tags = jQuery('.js-tag:checked');
    var styles = jQuery('.js-openStyle');

    var selectedTags = [];
    tags.each(function(i, el) {
        selectedTags.push(jQuery(el).val());
    });

    if (selectedTags.length) {
        styles.each(function (i, el) {
            var blnShowStyle = false;
            var _this = jQuery(el);
            var tags = _this.data('tags');
            if (tags !== '') {
                tags = tags.split(',');

                jQuery.each(tags, function(key, tag) {
                    if (jQuery.inArray(tag, selectedTags) !== -1) {
                        blnShowStyle = true;
                    }
                });
            } else {
                blnShowStyle = false;
            }

            if (blnInit) {
                if (blnShowStyle) showStyle(_this);
				else hideStyle(_this);
            } else {
                if (blnShowStyle) showStyle(_this);
				else hideStyle(_this);
            }
        });
    } else {
        styles.each(function(i, el) {
            var _this = jQuery(el);
            if (blnInit) showStyle(_this);
            else showStyle(_this);
        });
    }

	function showStyle(e){
		e.show();
        window.setTimeout(function() {
            e.css({'opacity': 1, 'visibility': 'visible'});
        }, 10);
		animateGrid();
	}

	function hideStyle(e){
        e.hide();
		animateGrid();
	}

    jQuery('.js-filterCount').html(selectedTags.length);

    sessionStorage.setItem('selectedFilters', selectedTags.join(','));
}

function calculate_configuration_dimensions() {
    if (jQuery(itemSelector).length == 0) {
        jQuery('.js-configuration-measurements').attr('style', 'display: none!important');
    } else {
        var nbrLeft = 10000,
            nbrRight = 0,
            nbrTop = 10000,
            nbrBottom = 0;


        jQuery(itemSelector).each(function (i, el) {
            var blnAttributeHeightIncluded = false;
            var $objItem = jQuery(el);

            nbrLeft = Math.min(nbrLeft, $objItem.position().left);
            nbrRight = Math.max(nbrRight, $objItem.position().left + $objItem.width());

            var nbrItemTop = $objItem.position().top;
            $objItem.find('img').each(function (j, img) {
                var $objImg = jQuery(img);
                if (jQuery.inArray($objImg.data('type-element'), ['faucet', 'lighting']) !== -1 && !blnAttributeHeightIncluded) {
                    nbrItemTop += $objImg.position().top;
                    blnAttributeHeightIncluded = true;
                }
            });

            nbrTop = Math.min(nbrTop, nbrItemTop);
            nbrBottom = Math.max(nbrBottom, $objItem.position().top + $objItem.height());
        });

        var nbrWidth = (nbrRight - nbrLeft);
        //var nbrHeight = nbrBottom - nbrTop; // height of configuration
        var nbrHeight = (jQuery(destinationSelector).height() - nbrTop - 1); // height from floor

        var nbrWidthCm = Math.round(nbrWidth / nbrRatio);
        var nbrHeightCm = Math.round(nbrHeight / nbrRatio);

        //console.log(nbrLeft, nbrRight, nbrTop, nbrWidth, nbrHeight, nbrWidthCm, nbrHeightCm);

        var $objConfigurationWidth = jQuery('.js-configuration-width');
        var $objConfigurationHeight = jQuery('.js-configuration-height');

        $objConfigurationWidth.width(nbrWidth).css({
            left: nbrLeft,
            top: nbrTop - 20
        });

        $objConfigurationHeight.height(nbrHeight).css({
            left: nbrLeft - 20,
            top: nbrTop
        });

        $objConfigurationWidth.find('span.measurement').html(nbrWidthCm);
        $objConfigurationHeight.find('span.measurement').html(nbrHeightCm);

        jQuery('.js-configuration-measurements').css({ 'display' : '' });
    }
}

function get_elements_json() {
    var $container = jQuery(destinationSelector);
    var containerDimensions = { width: $container.width(), height: $container.height() };
    var elements = [],
        skus = [],
        configuration;

    var $items = jQuery(itemSelector);
    $items.each(function(i, el) {
        var $item = jQuery(el);

        $item.find('img').each(function(j, img) {
            $img = jQuery(img);
            skus.push($img.data('sku'));
        });
    });

    jQuery.ajax({
        url: '/includes/get_elements_json.php',
        type: 'post',
        async: false,
        dataType: 'json',
        data: {
            skus: JSON.stringify(skus)
        },
        success: function(elements3DAttributes) {
            var element3DSettings, attribute3DSettings, threeD, defaultWallDistance = 0;

            jQuery.each(elements3DAttributes, function(i, el) {
                if (jQuery.inArray(el['kind'], [ 'OB', 'OBS', 'OBE' ]) > -1 && el['image_3d_zpos'] > 0) {
                    defaultWallDistance = el['image_3d_zpos'];
                }
            });

            $items.each(function(i, el) {
                var $item = jQuery(el);

                var element = {
                    main: {},
                    attributes: []
                };

                $item.find('img').each(function(j, img) {
                    $img = jQuery(img);

                    if ($img.hasClass('element')) {
                        element3DSettings = elements3DAttributes[$img.data('sku')] || {};

                        threeD = $img.data('3d');
                        if (threeD !== '') {
                            if (element3DSettings['image_3d_add_color'] === '1' && $img.data('selected_color') !== '') {
                                threeD = threeD.replace('.fbx', '_' + $img.data('selected_color').padStart(4, '0') + '.fbx')
                            }
                            if (element3DSettings['image_3d_add_gripe'] === '1' && $img.data('selected_grip') !== '') {
                                threeD = threeD.replace('.fbx', '_' + $img.data('selected_grip') + '.fbx')
                            }
                        }

                        element.main = {
                            sku: $img.data('sku'),
                            selectedColor: $img.data('selected_color'),
                            selectedGrip: $img.data('selected_grip'),
                            selectedShelf: $img.data('selected_shelf'),
                            selectedLinkSku: $img.data('selected_linksku'),
                            left: $item.position().left,
                            top: $item.position().top,
                            width: $img.width(),
                            height: $img.height(),
                            folder: $img.data('kind-code'),
                            threeD: threeD
                        }

                        if (defaultWallDistance > 0  && jQuery.inArray($img.data('kind-code'), [ 'AT', 'LV', 'WT', 'WK' ]) > -1) {
                            element.main['distance-from-wall'] = Math.round((defaultWallDistance + element3DSettings['image_3d_zpos']) * nbrRatio) + 'px';
                        } else if (element3DSettings['image_3d_zpos'] && element3DSettings['image_3d_zpos'] > 0) {
                            element.main['distance-from-wall'] = Math.round(element3DSettings['image_3d_zpos'] * nbrRatio) + 'px';
                        }

                    } else {
                        if (jQuery.inArray($img.data('type-element'), ['grip', 'griplist']) !== -1 && element3DSettings['image_3d_add_gripe'] === '1') {
                        } else {
                            attribute3DSettings = elements3DAttributes[$img.data('sku')] || {};

                            threeD = $img.data('3d');
                            if (threeD !== '') {
                                if (jQuery.inArray($img.data('type-element'), ['grip', 'griplist']) !== -1 && element3DSettings['gripe_3d_postfix'] !== '') {
                                    threeD = threeD.replace('.fbx', '_' + element3DSettings['gripe_3d_postfix'] + '.fbx')
                                }
                            }

                            element.attributes.push(
                                {
                                    sku: $img.data('sku'),
                                    type: $img.data('type-element'),
                                    left: $img.position().left,
                                    width: $img.width(),
                                    height: $img.height(),
                                    folder: $img.data('kind-code'),
                                    threeD: threeD
                                }
                            );

                            if ($img.data('3d-position') != null) {
                                if ($img.data('position-from') === 'top') {
                                    element.attributes[element.attributes.length - 1].top = $img.data('3d-position');
                                } else {
                                    element.attributes[element.attributes.length - 1].bottom = $img.data('3d-position');
                                }
                            } else {
                                element.attributes[element.attributes.length - 1].top = $img.position().top;
                            }

                            if ($img.data('upsidedown') != null) {
                                element.attributes[element.attributes.length - 1].upsidedown = !!$img.data('upsidedown');
                            }
                        }
                    }
                });

                elements.push(element);

            });

            configuration = {
                dimensions: containerDimensions,
                elements: elements
            };
        }
    });

    return configuration;
}

function format_elements_json(key, value) {
    if (jQuery.inArray(key, ['left', 'top', 'bottom', 'width', 'height']) > -1) {
        return value + 'px';
    }
    return value;
}

/*
function update_element_selector(ID_kinds) {
	var vSlideSelector = '#main.configure .vertical-gallery .v-slide';
	jQuery(vSlideSelector).css({ 'position': 'absolute', 'left':-9999, 'top': -9999 });
	jQuery(vSlideSelector + '.kind-' + ID_kinds).css({ 'position': 'relative', 'left':0, 'top': 0 });
	window.setTimeout(function() {
		jQuery(vSlideSelector + '.kind-' + ID_kinds + ' .preview-gallery').slick('slickGoTo', 0, true);
	}, 200);
}
*/
function add_item(el, data) {
	if (data != null) {
		var item = jQuery("<img>");
		jQuery.each(data, function(index, value) {
			item.data(index, value);
		});
	} else {
        item = jQuery(el).find('.c-editor__product-img');
        item.data('width', Math.round(item.data('original-width') * nbrRatio));
        item.data('height', Math.round(item.data('original-height') * nbrRatio));
	}

    selected_option = '';
    update_configurator_count(1);

    var position = item.data('position');
	var destination = jQuery(destinationSelector);
	
	var newItem = jQuery('<div class="item" data-position="' + position + '">');
	var img = jQuery('<img data-id="' + item.data('id') + '" data-sku="' + item.data('sku') + '" data-3d="' + item.data('3d') + '" data-group="' + item.data('group') + '" data-kind="' + item.data('kind') + '" data-kind-code="' + item.data('kind-code') + '" data-category="' + item.data('category') + '" class="element">');
	
	//retrieve the rescaled image and update the img src
	get_image(item.data(), img);
	
	img.one('load', function() {
 		if (parseInt(item.data('width')) > 0) {
			img.data('width', item.data('width')).attr('width', item.data('width'));
		}

        if (parseInt(item.data('height')) > 0) {
            img.data('height', item.data('height')).attr('height', item.data('height'));
        }
		newItem.append(img);
		
		newItem.appendTo(destination);
		
		newItem.on('mousedown touch', function(event) {
			select_item(jQuery(this));
		});
		
		newItem.data('maxVerticalMove', nbrMaxVerticalMove);

		position_new_item(newItem);	

		show_element_attributes(img);
			
		//var containment = destinationSelector;
		var containment = calculate_item_containment(newItem, position);
		newItem.data('containment', containment);
		
		select_item(newItem);
		
		make_item_draggable(newItem);
		
		img = null;
		newItem = null;
		item = null;

        calculate_configuration_dimensions();
    });
}

function duplicate_item() {
	var newItem = currentElement.clone(true);
	var destination = jQuery(destinationSelector);
	
	newItem.appendTo(destination);
	
	position_new_item(newItem);	

	select_item(newItem);
	
	make_item_draggable(newItem);

    update_configurator_count(1);

    newItem = null;

    calculate_configuration_dimensions();
}

function move_item(direction) {
	if (!isButtonPressed) return;
	if (isMovingItem) return;
	if (currentElement == null) return;
	
	isMovingItem = true;
	
	var item = currentElement;
	var parent = jQuery(destinationSelector);
	var itemPosition = item.position();
	var itemOffset = item.offset();
	
	var containment = item.data('containment');
	
	if (direction == 'left') {
		if (itemPosition.left > 0) {
			if (jQuery.isArray(containment) && itemOffset.left <= containment[0]) {
			} else {
				item.css({ 'left': Math.max(0, itemPosition.left - arrSnapGrid[0]) });
			}
		}
	} else if (direction == 'right') {
		if (itemPosition.left + item.outerWidth() < parent.outerWidth()) {
			if (jQuery.isArray(containment) && itemOffset.left >= containment[2]) {
			} else {
				item.css({ 'left': Math.min(parent.outerWidth() - item.outerWidth(), itemPosition.left + arrSnapGrid[0]) });
			}
		}
	} else if (direction == 'up') {
		if (itemPosition.top > 0) {
			if (jQuery.isArray(containment) && itemOffset.top <= containment[1]) {
			} else {
				item.css({ 'top': Math.max(0, itemPosition.top - arrSnapGrid[1]) });
			}
		}
	} else if (direction == 'down') {
		if (itemPosition.top + item.outerHeight() < parent.outerHeight()) {
			if (jQuery.isArray(containment) && itemOffset.top >= containment[3]) {
			} else {
				item.css({ 'top': Math.min(parent.outerHeight() - item.outerHeight(), itemPosition.top + arrSnapGrid[1]) });
			}
		}
	}

    calculate_configuration_dimensions();

    isMovingItem = false;
}

function remove_item() {
	if (currentElement != null) {
		currentElement.remove();
		currentElement = null;
        selected_option = '';
        update_configurator_count(-1);

        jQuery('.popup-content').hide();
        jQuery('.c-editor__menu .mm-ocd').show();

        calculate_configuration_dimensions();
    }
}

function select_item(el) {
	if (!el.is(currentElement)) {
		el.parent().find('.item').removeClass('border');
		currentElement = el;
		restack_items();
		el.addClass('border');
	
		get_element_options();

        /*
		var typeSlider = jQuery('#main.configure .popup-content .element-type .preview-gallery');
		
		typeSlider.slick('unslick');
		typeSlider.find('.slide').remove();

		jQuery('#main.configure .slideshow-aside .holder .v-slide.kind-' + el.find('img.element').data('kind') + ' .preview-gallery' + ' .slide').each(function() {
			typeSlider.append('<div class="slide">' + jQuery(this).html() + '</div>');
		});
			
		setTimeout(function() {
			typeSlider.slick(previewGalleryConfiguration);
			
			var slideIndex = jQuery('#main.configure .slideshow-aside .popup-content .element-type .slide img.item[data-group="' + el.find('img.element').data('group') + '"]').closest('.slide').data('slick-index');
			typeSlider.slick('slickGoTo', slideIndex, false);
		}, 200);
        */

        var img = el.find('img.element');

        var typeOptions = jQuery('#main.configure .popup-content .element-type:not(.element-extra) .c-editor__option-wrapper');
        typeOptions.html('');

        var elementCategories = img.data('category').toString().split(',');

        jQuery.each(elementCategories, function(i, category) {
            if (category !== '') {
                jQuery('#main.configure .mm-ocd .mm-spn__list-title[data-value=' + category + '] + ul .c-editor__product-img-wrapper').each(function () {
                    var groupImg = jQuery(this).find('.c-editor__product-img').clone(true);
                    groupImg.removeClass('c-editor__product-img').addClass('c-editor__option-img');
                    if (groupImg.data('group') == img.data('group')) groupImg.addClass('c-editor__option-img--active');
                    typeOptions.append(groupImg);
                });
            }
        });

        typeOptions.find('img').tooltip({
            position:{
                my: 'center top',
                at: 'center bottom+2'
            }
        });

        selected_option = '';

        jQuery('.popup-content').show();
        jQuery('.c-editor__menu .mm-ocd').hide();

		/*
		if (!jQuery('.popup-content .element-position').hasClass('active')) {
			jQuery('.popup-content .options-list').find('li').removeClass('active');
			jQuery('.popup-content .options-list').find('.accordion-slide').css({ 'top': -9999, 'left': -9999, 'position': 'absolute' });
			jQuery('.popup-content .options-list').find('li.element-position a').click();
		}
		*/
    }
}

function position_new_item(el) {
	var position = el.data('position');
	var destination = jQuery(destinationSelector);
	
	el.css({ 'top': -9999,	'left': 0 });
	
	var top = 0;
	if (position == 'middle') {
		top = Math.round((destination.height() - el.outerHeight()) / 2);
	} else if (position == 'bottom') {
		top = Math.round(destination.height() - el.outerHeight());
	}
		
	if (top + el.outerHeight() > destination.height()) {
		top = destination.height() - el.outerHeight();
	}
	el.css({ 'top': top, 'visibility': 'visible' });
}

function get_element_options() {
	var optionsContainer = jQuery("#main.configure .popup-content .popup-holder .options-list");
	//jQuery('.form.form-options .options-title, .form.form-options .buttons').hide();
	optionsContainer.find('li.element-extra').remove();

	var arrData = {
        'ID': currentElement.find('img.element').data('id'),
        'selected_color': currentElement.find('img.element').data('selected_color'),
        'selected_grip': currentElement.find('img.element').data('selected_grip'),
		'selected_shelf': currentElement.find('img.element').data('selected_shelf'),
        'selected_linksku': currentElement.find('img.element').data('selected_linksku'),
		'selected_customwidth': currentElement.find('img.element').data('selected_customwidth'),
        'selected_position_wk_1': currentElement.find('img.element').data('selected_position_wk_1'),
        'selected_position_wk_2': currentElement.find('img.element').data('selected_position_wk_2'),
		'position_faucet': currentElement.find('img.element').data('position_faucet'),
        'action':  'get'
    }

	jQuery.ajax({
		url: '/includes/get_element_options.php',
		type: 'POST',
		data: arrData,
		dataType: 'json',
		cache: false,
		success: function(data) {
			if (data.status) {
				if (data.options != null) {
                    optionsContainer.find('li.options-title').show();

					jQuery.each(data.options, function(optionIndex, option) {
                        /**
                         * add-in to not show options that have only one choice
                         */
                        var blnHideNoChoiceOptionsException = false;
                        if (arrHideNoChoiceOptionsExceptions instanceof Object && arrHideNoChoiceOptionsExceptions.hasOwnProperty(option.code)) {
                            if (arrHideNoChoiceOptionsExceptions[option.code] instanceof Object) {
                                if (jQuery.inArray(currentElement.find('img.element').data('kind'), arrHideNoChoiceOptionsExceptions[option.code]) >= 0) {
                                    blnHideNoChoiceOptionsException = true;
                                }
                            }
                        }
                        var blnHideOption = (blnHideNoChoiceOptions && !blnHideNoChoiceOptionsException && data.results[optionIndex] == 1);
                        /**
                         * end add-in
                         */

                        optionsContainer.append('<li class="element-' + option.code + ' element-extra' + (blnHideOption ? ' hidden' : (selected_option === option.code ? ' active' : '')) + '"><a href="#" class="opener"><h4>' + option.label.toLowerCase() + '</h4></a><div class="accordion-slide"' + (selected_option !== option.code ? ' style="position:absolute; left:-9999px; top:-9999px;"' : '') + '><div class="option-container"></div></div></li>');
						
						var optionContainer = optionsContainer.find('li.element-' + option.code + '.element-extra .option-container');
						
						var optionSelect = jQuery('<div class="select select-' + option.code + ' c-editor__option-wrapper"></div>');
						if (option.code.substr(0, 7) == 'custom_' || option.code.substr(0, 12) == 'position_wk_') {
							var optionSelectContent = '<div class="clearfix"><select name="' + option.code + '" id="' + option.code + '" onchange="update_element_options(jQuery(this));" data-placeholder="' + strSelectOption + '">';
							jQuery.each(option.options, function (optionValueIndex, optionValue) {
								optionSelectContent += '<option value="' + optionValue.value + '"' + (option.elementValue == optionValue.value ? ' selected="selected"' : '') + '>' + optionValue.label + '</option>';
							});
							optionSelectContent += '</select></div>';
							optionSelect.append(optionSelectContent);

							optionContainer.append(optionSelect);

							jQuery('#' + option.code).chosen({
                                width: optionsContainer.width() + 'px'
                            });
						} else if (option.code == 'colors' && data.colorsRal) {
							var optionSelectContent = '<div class="clearfix"><select name="' + option.code + '" id="' + option.code + '" onchange="update_element_options(jQuery(this));" data-placeholder="' + strSelectOption + '">';
							jQuery.each(option.options, function (optionValueIndex, optionValue) {
								optionSelectContent += '<option value="' + optionValue.value + '"' + (option.elementValue == optionValue.value ? ' selected="selected"' : '') + ' data-class="ral' + optionValue.value.substr(-4,4) + '">' + optionValue.description.substr(6) + '</option>';
							});
							optionSelectContent += '</select></div>';
							optionSelect.append(optionSelectContent);

							optionContainer.append(optionSelect);

							jQuery('#' + option.code).on('chosen:ready', function(event, params) {
								format_ral_current_option(option.code);
							}).on('chosen:showing_dropdown change', function(event, params) {
								format_ral_current_option(option.code);
								format_ral_options(option.code);
							}).chosen({
								search_contains: true,
                                width: optionsContainer.width() + 'px'
							});

							jQuery('div#' + option.code + '_chosen').on('keyup', '.chosen-search-input', function() {
								format_ral_options(option.code);
							})

						} else {
                            jQuery.each(option.options, function (optionValueIndex, optionValue) {
                                if (optionValue.image != null) {
                                    if (option.code == 'colors' && data.colorsSelector) {
                                        optionSelect.append('<input type="radio" name="' + option.code + '" id="' + option.code + '_' + optionValueIndex + '" value="' + optionValue.value + '"' + (option.elementValue == optionValue.value ? ' checked="checked"' : '') + ' onchange="update_element_options(jQuery(this));" /><span class="c-editor__option-color ' + (option.elementValue == optionValue.value ? 'c-editor__option-color--active"' : '') + '"' + (optionValue.description != null ? ' title="' + optionValue.description + '"' : '') + ' onClick="jQuery(this).prev().click()"><img src="' + optionValue.image + '"><span>' + optionValue.label + '</span>');

                                    } else {
                                        optionSelect.append('<input type="radio" name="' + option.code + '" id="' + option.code + '_' + optionValueIndex + '" value="' + optionValue.value + '"' + (option.elementValue == optionValue.value ? ' checked="checked"' : '') + ' onchange="update_element_options(jQuery(this));" /><img class="c-editor__option-img ' + (option.elementValue == optionValue.value ? 'c-editor__option-img--active"' : '') + '"' + (optionValue.label != null ? ' title="' + optionValue.label + '"' : '') + ' src="' + optionValue.image + '" onClick="jQuery(this).prev().click()">');
                                    }
                                } else {
                                    optionSelect.append('<div class="c-editor__option-mesure ' + (option.elementValue == optionValue.value ? 'c-editor__option-mesure--active"' : '') + '"' + (optionValue.description != null ? ' title="' + optionValue.description + '"' : '') + '><input type="radio" name="' + option.code + '" id="' + option.code + '_' + optionValueIndex + '" value="' + optionValue.value + '"' + (option.elementValue == optionValue.value ? ' checked="checked"' : '') + ' onchange="update_element_options(jQuery(this));" /><label for="' + option.code + '_' + optionValueIndex + '"><span>' + optionValue.label + '</span></label></div>');
                                }
                            });
                            optionContainer.append(optionSelect);
                        }
					});

                    jQuery('.popup-holder span.c-editor__option-color, .popup-holder img.c-editor__option-img').tooltip({
                        position: {
                            my: 'center top',
                            at: 'center bottom+2'
                        }
                    });

					//jQuery('.form.form-options .options-title, .form.form-options .buttons').show();
	
					init_accordion();

                    if (!jQuery('.options-list li[class^="element-"].active').length) {
                        var selectedElement;
                        if (selected_option === '') {
                            selectedElement = jQuery('.options-list .element-extra:not(:hidden)').eq(0);
                            selectedElement.find('.opener').click();
                        }
                    }

                    if (!jQuery('.options-list .element-extra:not(:hidden)').length) {
                        optionsContainer.find('li.options-title').hide();
                    }

                } else {
                    optionsContainer.find('li.options-title').hide();
				}
			}
        }
	});
}

function update_element_options(selectedOption) {
	var selectedOptions = [];
	var blnSelectOption = false;
	var blnSelectElementValue = false;
	var blnHasElementValue = false;
	var blnSkipOption = true;
	var blnDisableOption = false;
	var nextOption;
	var optionsContainer = jQuery('#main.configure .popup-content .popup-holder .options-list');
	
	var options = optionsContainer.find('.element-extra .select');
	options.each(function() {
		var currentOption = jQuery(this).find('input[type=radio]:checked, select');
		selectedOptions.push(currentOption.val());
		if (currentOption.attr('name') == selectedOption.attr('name')) {
			//return false;
		}
	});
	
	var img = currentElement.find('img.element');
    //console.log(img);
	
	jQuery.ajax({
		url: '/includes/get_element_options.php',
		type: 'POST',
		data: {
			'ID': img.data('id'),
			'selectedOptions': selectedOptions,
			'selected_color': img.data('selected_color'),
			'selected_grip': img.data('selected_grip'),
			'selected_shelf': img.data('selected_shelf'),
			'selected_linksku': img.data('selected_linksku'),
            'position_faucet': img.data('position_faucet'),
			'selectedOption': selectedOption.attr('name'),
			'action': 'update'
		},
		dataType: 'json',
		cache: false,
		success: function(data) {
			if (data.status) {
				if (data.options != null) {
                    optionsContainer.find('li.options-title').show();
                    selected_option = selectedOption.attr('name');

					jQuery.each(data.options, function(optionIndex, option) {
						var optionSelect = optionsContainer.find('.select-' + option.code);
						optionSelect.closest('.element-extra').removeClass('no-selection');
                        /**
                         * add-in to not show options that have only one choice
                         */
                        var blnHideNoChoiceOptionsException = false;
                        if (arrHideNoChoiceOptionsExceptions instanceof Object && arrHideNoChoiceOptionsExceptions.hasOwnProperty(option.code)) {
                            if (arrHideNoChoiceOptionsExceptions[option.code] instanceof Object) {
                                if (jQuery.inArray(currentElement.find('img.element').data('kind'), arrHideNoChoiceOptionsExceptions[option.code]) >= 0) {
                                    blnHideNoChoiceOptionsException = true;
                                }
                            }
                        }
                        if (blnHideNoChoiceOptions && !blnHideNoChoiceOptionsException && data.results[optionIndex] == 1) optionSelect.closest('.element-extra').addClass('hidden');
                        else optionSelect.closest('.element-extra').removeClass('hidden');
                        /**
                         * end add-in
                         */

                        if (option.code == selectedOption.attr('name')) {
							blnSkipOption = false;
						} else if (!blnSkipOption) {
							blnSelectOption = false;
							blnHasElementValue = array_search(option.elementValue, 'value', option.options);
							
							optionSelect.html('');
							
							if (data.results[optionIndex] == 1) {
								blnSelectOption = true;
							} else if (blnHasElementValue) {
							} else {
								if (nextOption == null) {
									nextOption = option.code;
								} else {
									blnDisableOption = true;
								}
							}

                            if (option.code.substr(0, 7) == 'custom_' || option.code.substr(0, 12) == 'position_wk_') {
                                var optionSelectContent = '<div class="clearfix"><select name="' + option.code + '" id="' + option.code + '" onchange="update_element_options(jQuery(this));" data-placeholder="' + strSelectOption + '"><option style="display:none;">' + strSelectOption + '</option>';
                                jQuery.each(option.options, function (optionValueIndex, optionValue) {
                                    blnSelectElementValue = (optionValue.value == option.elementValue);
                                    optionSelectContent += '<option value="' + optionValue.value + '"' + (blnSelectOption || blnSelectElementValue ? ' selected="selected"' : '') + '>' + optionValue.label + '</option>';
                                });
                                optionSelectContent += '</select></div>';
                                optionSelect.append(optionSelectContent);

                                jQuery('#' + option.code).chosen({
                                    width: optionsContainer.width() + 'px'
                                });
							} else if (option.code == 'colors' && data.colorsRal) {
								var optionSelectContent = '<div class="clearfix"><select name="' + option.code + '" id="' + option.code + '" onchange="update_element_options(jQuery(this));" data-placeholder="' + strSelectOption + '"><option style="display:none;">' + strSelectOption + '</option>';
								jQuery.each(option.options, function (optionValueIndex, optionValue) {
									blnSelectElementValue = (optionValue.value == option.elementValue);
									optionSelectContent += '<option value="' + optionValue.value + '"' + (blnSelectOption || blnSelectElementValue ? ' selected="selected"' : '') + ' data-class="ral' + optionValue.value.substr(-4,4) + '">' + optionValue.description.substr(6) + '</option>';
								});
								optionSelectContent += '</select></div>';
								optionSelect.append(optionSelectContent);

								jQuery('#' + option.code).on('chosen:ready', function(event, params) {
									format_ral_current_option(option.code);
								}).on('chosen:showing_dropdown change', function(event, params) {
									format_ral_current_option(option.code);
									format_ral_options(option.code);
								}).chosen({
									search_contains: true,
                                    width: optionsContainer.width() + 'px'
								});

								jQuery('div#' + option.code + '_chosen').on('keyup', '.chosen-search-input', function() {
									format_ral_options(option.code);
								})

							} else {
                                jQuery.each(option.options, function (optionValueIndex, optionValue) {
                                    blnSelectElementValue = (optionValue.value == option.elementValue);

                                    if (optionValue.image != null) {
                                        if (option.code == 'colors' && data.colorsSelector) {
                                            optionSelect.append('<input type="radio" name="' + option.code + '" id="' + option.code + '_' + optionValueIndex + '" value="' + optionValue.value + '"' + (blnSelectOption || blnSelectElementValue ? ' checked="checked"' : '') + ' onchange="update_element_options(jQuery(this));" /><span class="c-editor__option-color ' + (blnSelectOption || blnSelectElementValue ? 'c-editor__option-color--active"' : '') + '"' + (optionValue.description != null ? ' title="' + optionValue.description + '"' : '') + ' onClick="jQuery(this).prev().click()"><img src="' + optionValue.image + '"><span>' + optionValue.label + '</span>');

                                        } else {
                                            optionSelect.append('<input type="radio" name="' + option.code + '" id="' + option.code + '_' + optionValueIndex + '" value="' + optionValue.value + '"' + (blnSelectOption || blnSelectElementValue ? ' checked="checked"' : '') + ' onchange="update_element_options(jQuery(this));" /><img class="c-editor__option-img ' + (blnSelectOption || blnSelectElementValue ? 'c-editor__option-img--active"' : '') + '"' + (optionValue.label != null ? ' title="' + optionValue.label + '"' : '') + ' src="' + optionValue.image + '" onClick="jQuery(this).prev().click()">');
                                        }
                                    } else {
                                        optionSelect.append('<div class="c-editor__option-mesure ' + (blnSelectOption || blnSelectElementValue ? 'c-editor__option-mesure--active"' : '') + '"' + (optionValue.description != null ? ' title="' + optionValue.description + '"' : '') + '><input type="radio" name="' + option.code + '" id="' + option.code + '_' + optionValueIndex + '" value="' + optionValue.value + '"' + (blnSelectOption || blnSelectElementValue ? ' checked="checked"' : '') + ' onchange="update_element_options(jQuery(this));" /><label for="' + option.code + '_' + optionValueIndex + '"><span>' + optionValue.label + '</span></label></div>');
                                    }
                                });
                            }
							
							if (blnDisableOption) {
								optionSelect.closest('.element-extra').removeClass('no-selection').addClass('disabled');
							} else {
								optionSelect.closest('.element-extra').removeClass('disabled');
								if (!blnSelectOption && !blnHasElementValue) {
									optionSelect.closest('.element-extra').addClass('no-selection');
								}
									
							}
						}
					});

                    jQuery('.popup-holder span.c-editor__option-color, .popup-holder img.c-editor__option-img').tooltip({
                        position: {
                            my: 'center top',
                            at: 'center bottom+2'
                        }
                    });
					
					if (nextOption != null) {
						optionsContainer.find('.element-' + nextOption + ' .opener').click();
						optionsContainer.find('.element-' + nextOption).nextAll().addClass('disabled');
					} else {
						//optionsContainer.find('.element-' + selectedOption.attr('name') + ' .opener').click();
						update_selection();
					}

                    if (!jQuery('.options-list .element-extra:not(:hidden)').length) {
                        optionsContainer.find('li.options-title').hide();
                    }

                } else {
                    optionsContainer.find('li.options-title').hide();
				}
			}
        }
	});
}

function update_selection() {
	var selectedOptions = [];
	var options = jQuery('#main.configure .popup-content .popup-holder .options-list .element-extra .select');
	options.each(function() {
		selectedOptions.push(jQuery(this).find('input[type=radio]:checked, select').val());
	});
	jQuery.ajax({
		url: '/includes/update_selection.php',
		type: 'POST',
		data: {
			'ID': currentElement.find('img.element').data('id'),
			'selectedOptions': selectedOptions,
            'nbrRatio': nbrRatio
		},
		dataType: 'json',
		cache: false,
		success: function(data) {
			if (data.status) {
				if (data.count == 0) {
					jQueryAlert(strNoElements, strError);
				} else if (data.count > 1) {
					var arrSKUs = [];
					for (var i = 0; i < data.count; i++) {
						arrSKUs.push(data['element'][i]['sku']);
					}
					jQueryAlert(strTooManyElements + '\nSKUs: ' + arrSKUs.join(','), strError);
				} else {
					if (data.selected_color != undefined) selected_color = data.selected_color;
					if (data.selected_grip != undefined) selected_grip = data.selected_grip;
					if (data.selected_shelf != undefined) selected_shelf = data.selected_shelf;
					if (data.selected_linksku != undefined) selected_linksku = data.selected_linksku;

					currentElement.find('img:not(.element)').remove();
					var img = currentElement.find('img.element');
			
					var imageData = {
						'id': data.element[0]['ID'],
						'group': data.element[0]['ID_groups'],
						'width': data.element[0]['image_width'],
						'height': data.element[0]['image_height'],
						'element': strElementImagesDir + data.element[0]['sub_folder'] + '/A/' + data.element[0]['filename_view'] + '.png'
					};
					if (data.selected_customwidth != undefined) imageData['selected_customwidth'] = data.selected_customwidth;
                    if (data.selected_position_wk_1 != undefined) imageData['selected_position_wk_1'] = data.selected_position_wk_1;
                    if (data.selected_position_wk_2 != undefined) imageData['selected_position_wk_2'] = data.selected_position_wk_2;

					//retrieve the rescaled image and update the img src
					get_image(imageData, img);
					
					img.one('load', function() {
						img.data('id', imageData['id']).attr('data-id', imageData['id']);
						img.data('group', imageData['group']).attr('data-group', imageData['group']);
						if (parseInt(imageData['width']) > 0) {
							img.data('width', imageData['width']).width(data.element[0]['image_display_width']);
						}

                        if (parseInt(imageData['height']) > 0) {
                            img.data('height', imageData['height']).height(imageData['height']);
                        }
						show_element_attributes(img);
						
						get_element_options();
						
						var containment = calculate_item_containment(currentElement, currentElement.data('position'));
						currentElement.data('containment', containment);
			
						reposition_item();
			
						make_item_draggable(currentElement);

                        calculate_configuration_dimensions();

						img = null;
						item = null;
					});
				}
			}
		}
	});
}

function show_element_attributes(img) {
	var element = img.data('element-data');

	if (element['lighting_module'] != undefined) {
		var nbrLightingWidth = element['lighting_module_dimensions']['width'];
		var nbrLightingHeight = element['lighting_module_dimensions']['height'];
		var nbrLightings = element['number_of_lightings'];
	
		var nbrLightingArea = img.data('width') / nbrLightings;
		for (var i = 0; i < nbrLightings; i++) {
			var nbrLightingLeft = Math.round((nbrLightingArea - nbrLightingWidth) / 2);
			img.parent().append('<img src="' + element['lighting_module'] + '" style="position:absolute; left: ' + Math.round(nbrLightingLeft + (i * nbrLightingArea))  + 'px; top: -' + nbrLightingHeight + 'px; width:' + nbrLightingWidth + 'px; height: ' + nbrLightingHeight + 'px;" width="' + nbrLightingWidth + '" height="' + nbrLightingHeight + '" data-type-element="lighting" data-sku="' + (typeof element['selected_linksku'] !== 'undefined' ? element['selected_linksku'] : element['lightings']) + '" data-3d="' + (typeof element['selected_linksku_3d'] !== 'undefined' ? element['selected_linksku_3d'] : element['lightings_3d']) + '" data-kind-code="' + (typeof element['selected_linksku_kind_code'] !== 'undefined' ? element['selected_linksku_kind_code'] : element['lightings_kind_code']) + '">');
		}
	
	} else if (element['grips_type'] == "GRIP" && jQuery.isArray(element['position_grip']) && typeof element['grip_image_dimensions'] === 'object') {
		var nbrGripWidth = element['grip_image_dimensions']['width'];
		var nbrGripHeight = element['grip_image_dimensions']['height'];
		
		var nbrGripArea = img.data('width');

		jQuery.each(element['position_grip'], function(nbrPositionIndex, objPosition) {
			if (objPosition['position_offset'] != 0) var nbrGripLeft = Math.round((nbrGripArea * objPosition['position'] / 100) + objPosition['position_offset'] * nbrRatio);
			else var nbrGripLeft = Math.round((nbrGripArea * objPosition['position'] / 100) - Math.round(nbrGripWidth / 2));

			if (objPosition['distance'] != '') {
				var nbrGripTop = (objPosition['from'] == 'top' ? 'top: ' : 'bottom: ') + Math.round(objPosition['distance'] * nbrRatio) + 'px';
                var strPositionFrom = (objPosition['from'] == 'top' ? 'top' : 'bottom');
			} else if (objPosition['percentage'] != '') {
				var nbrGripTop = 'top: ' + Math.round((img.height() * objPosition['percentage'] / 100) - Math.round(nbrGripHeight / 2)) + 'px';
                var strPositionFrom = 'top';
			}

            if (objPosition['distance_3d'] != '') {
                var strGripPosition3D = ' data-3d-position="' + Math.round(objPosition['distance_3d'] * nbrRatio) + '"';
            }

            img.parent().append('<img src="' + element['grip_image'] + '" style="position:absolute; ' + nbrGripTop + '; left: ' + nbrGripLeft + 'px; width:' + nbrGripWidth + 'px; height: ' + nbrGripHeight + 'px;" width="' + nbrGripWidth + '" height="' + nbrGripHeight + '"' + (objPosition['upsidedown'] == '1' ? ' class="upsidedown" data-upsidedown="1"' : ' data-upsidedown="0"') + ' data-type-element="grip" data-position-from="' + strPositionFrom + '" data-sku="' + element['selected_grip'] + '" data-3d="' + element['selected_grip_3d'] + '" data-kind-code="' + element['selected_grip_kind_code'] + '"' + (objPosition['distance_3d'] != '' ? strGripPosition3D : '') + '>');
		});
	
	} else if (element['grips_type'] == "GRIPLIST" && jQuery.isArray(element['position_grip']) && typeof element['grip_image_dimensions'] === 'object') {
		var nbrGripHeight = element['grip_image_dimensions']['height'];
	
		var nbrGripArea = img.data('width');
		
		jQuery.each(element['position_grip'], function(nbrPositionIndex, objPosition) {
			var nbrGripWidth = Math.round((nbrGripArea / objPosition['number'] * (objPosition['width_percentage'] != 0 ? objPosition['width_percentage'] / 100 : 1)));
            if (nbrGripWidth > nbrGripArea) {
                nbrGripWidth = nbrGripArea;
            }

			var nbrGripTop = (objPosition['from'] == 'top' ? 'top: ' : 'bottom: ') + Math.round(objPosition['distance'] * nbrRatio) + 'px';
            var strPositionFrom = (objPosition['from'] == 'top' ? 'top' : 'bottom');

            if (objPosition['distance_3d'] != '') {
                var strGripPosition3D = ' data-3d-position="' + Math.round(objPosition['distance_3d'] * nbrRatio) + '"';
            }

            for(var i = 0; i < objPosition['number']; i++) {
				var nbrGripLeft = Math.round(nbrGripArea * objPosition['position'] / 100) + nbrGripWidth * i;
                img.parent().append('<img src="' + element['grip_image'] + '" style="position:absolute; ' + nbrGripTop + '; left: ' + nbrGripLeft + 'px; width:' + nbrGripWidth + 'px; height: ' + nbrGripHeight + 'px;" width="' + nbrGripWidth + '" height="' + nbrGripHeight + '"' + (objPosition['upsidedown'] == '1' ? ' class="upsidedown" data-upsidedown="1"' : ' data-upsidedown="0"') + ' data-type-element="griplist" data-position-from="' + strPositionFrom + '" data-sku="' + element['selected_grip'] + '" data-3d="' + element['selected_grip_3d'] + '" data-kind-code="' + element['selected_grip_kind_code'] + '"' +  (objPosition['distance_3d'] != '' ? strGripPosition3D : '') + '>');
			}
		});

	} else if (jQuery.isArray(element['position_faucet']) && element['position_faucet'].length) {
		var nbrFaucetWidth = element['faucet_image_dimensions']['width'];
		var nbrFaucetHeight = element['faucet_image_dimensions']['height'];

        var nbrFaucetArea = (typeof img.data('selected_customwidth') !== 'undefined' ? Math.round(img.data('selected_customwidth') * nbrRatio) : img.data('width'));

        var nbrFaucetLeft;
        jQuery.each(element['position_faucet'], function(nbrPositionIndex, objPosition) {
            if (objPosition['distance'] > 0) {
                if (objPosition['from'] == 'left') {
                    nbrFaucetLeft = Math.round((objPosition['distance'] * nbrRatio) - (nbrFaucetWidth / 2));
                } else if (objPosition['from'] == 'right') {
                    nbrFaucetLeft = Math.round(nbrFaucetArea - (objPosition['distance'] * nbrRatio) - (nbrFaucetWidth / 2));
                }
            } else if (objPosition['position'] > 0) {
                nbrFaucetLeft = Math.round((nbrFaucetArea * objPosition['position'] / 100) - (nbrFaucetWidth / 2));
            }

            var strFaucetImage = element['faucet_image'];
            var strFaucetImage3D = element['faucet_image_3d'];
            if (nbrPositionIndex > 0 && typeof element['faucet_image2'] !== 'undefined') {
                var strFaucetImage = element['faucet_image2'];
                var strFaucetImage3D = element['faucet_image2_3d'];
            }
            img.parent().append('<img src="' + strFaucetImage + '" class="faucet" style="position:absolute; top: -' + (nbrFaucetHeight + parseInt(objPosition['position_offset'])) + 'px; left: ' + nbrFaucetLeft + 'px; width:' + nbrFaucetWidth + 'px; height: ' + nbrFaucetHeight + 'px;" width="' + nbrFaucetWidth + '" height="' + nbrFaucetHeight + '" data-type-element="faucet" data-sku="" data-3d="' + strFaucetImage3D + '" data-kind-code="KR">');
        });

	} else if (element['wire_image'] != undefined) {
		var nbrWireWidth = Math.max(1, Math.round(element['wire_image_dimensions']['width'] * element['image_ratio']));
		var nbrWireHeight = Math.round(element['wire_image_dimensions']['height']);

		var nbrWireArea = img.data('width');
	
		var nbrWireLeft = Math.round((nbrWireArea - nbrWireWidth) / 2);
		
		img.parent().append('<img src="' + element['wire_image'] + '" style="position:absolute; top: -' + nbrWireHeight + 'px; left: ' + nbrWireLeft + 'px; width:' + nbrWireWidth + 'px; height: ' + nbrWireHeight + 'px;" width="' + nbrWireWidth + '" height="' + nbrWireHeight + '" data-type-element="wire" data-sku="" data-3d="" data-kind-code="">');
		
	}
	img.removeData('element-data');
}

function update_configurator_count(nbr) {
    var configuratorCount = jQuery('.configurator_count');

    if (nbr == 0) {
        configuratorCount.html(0);
    } else {
        var count = parseInt(configuratorCount.html());
        configuratorCount.html(count + nbr);
    }

}


function restack_items() {
	var minimumValue = 0;
	var group = jQuery.makeArray(jQuery(itemSelector));

	if (!group.length) { 
		return; 
	}

	group.sort(function(a, b) {
		return (parseInt(jQuery(a).css('zIndex'), 10) || 0) - (parseInt(jQuery(b).css('zIndex'), 10) || 0);
	});

	//minimumValue = parseInt(jQuery(group[0]).css('zIndex'), 10) || 0;
	
	jQuery(group).each(function(i) {
		jQuery(this).css('zIndex', minimumValue++);
	});
	
	currentElement.css('zIndex', minimumValue++);
	
	jQuery(itemSelector).each(function() {
		if (jQuery(this).has('img[src*="/LV/"]').length) {
			jQuery(this).css('zIndex', minimumValue++);
		}
	});
	
	if (currentElement.has('img[src*="/LV/"]').length) currentElement.css( "zIndex", minimumValue++);
}

function calculate_item_containment(el, position) {
	var destination = jQuery(destinationSelector);
	var destinationOffset = destination.offset();
	/*
	var elementPosition = el.position();
	var maxVerticalMove = el.data('maxVerticalMove');
	var elementHeight = Math.round(Math.min(destination.height(), el.outerHeight() + maxVerticalMove));
	var elementTop = 0;
	
	if (position == 'middle') {
		elementTop = Math.round((destination.height() - elementHeight) / 2);
	} else if (position == 'bottom') {
		elementTop = Math.round(destination.height() - elementHeight);
	}
	
	var containment = [
		destinationOffset.left, // x1
		destinationOffset.top + elementTop, // y1
		destinationOffset.left + destination.width() - el.outerWidth(), // x2
		destinationOffset.top + elementTop + elementHeight - el.outerHeight() //y2
	];

	//console.log(destinationOffset, destination.width(), destination.height(), elementPosition, el.outerWidth(), el.outerHeight(), elementHeight, elementTop, containment);
	*/
	
	var containment = [
		destinationOffset.left, // x1
		destinationOffset.top, // y1
		destinationOffset.left + destination.width() - el.outerWidth(), // x2
		destinationOffset.top + destination.height() - el.outerHeight() // y2
	]

	return containment;
}

function set_all_items_containment() {
	jQuery(itemSelector).each(function() {
		//var containment = destinationSelector;
		var containment = calculate_item_containment(jQuery(this), jQuery(this).data('position'));
		jQuery(this).data('containment', containment);
		
		make_item_draggable(jQuery(this));
	});

	allItemsContainmentStarted = false;
}

function set_containment_container_dimensions() {
	var wall = jQuery('#main.configure .wall');
	
	var left = wall.position().left;
	var width = wall.width();
	var height = wall.height();
	
	jQuery(destinationSelector).css({ 'width': width, 'height': height });
}

function reposition_item() {
	var containment = currentElement.data('containment');
	var elementOffset = currentElement.offset();
	
	var destination = jQuery(destinationSelector);
	var destinationOffset = destination.offset();
	
	if (elementOffset.top < containment[1]) {
		currentElement.css({ 'top': Math.round(containment[1] - destinationOffset.top) });
	} else if (elementOffset.top > containment[3]) {
		currentElement.css({ 'top': Math.round(containment[3] - destinationOffset.top) });
	}
	
	if (elementOffset.left < containment[0]) {
		currentElement.css({ 'left': Math.round(containment[0] - destinationOffset.left) });
	} else if (elementOffset.left > containment[2]) {
		currentElement.css({ 'left': Math.round(containment[2] - destinationOffset.left) });
	}
}

function make_item_draggable(el) {
	if (el.draggable('instance') != undefined) {
		el.off('.draggable');
		el.removeData('uiDraggable');
	}

	el.draggable({
		snap: true,
		snapMode: 'inner',
		snapTolerance: 2,
		containment: el.data('containment'),
		scroll: false,
		grid: arrSnapGrid,
        drag: function(event, ui) {
            calculate_configuration_dimensions();
        }
	});
}

function position_initial_items() {
    var configuratorHolder = jQuery('.c-editor__configurator');
    var slideshowSection = jQuery('.c-editor__configurator .slideshow-section');
    var slideshowContent = jQuery('.c-editor__configurator .slideshow-content');
    var wall = jQuery('.c-editor__configurator .wall');
    var arrWallDimensions = [ wall.width(), wall.height() ];
    var container = jQuery(destinationSelector);
    var items = jQuery(itemSelector);
    //var addItems = jQuery('.slideshow-aside img');
    var addItems = jQuery('.c-editor__menu .c-editor__products .c-editor__product .c-editor__product-img');

    // slideshow section max height is area between nav-bar (logo) and floor - 15px for extra spacing between the configurator and the header
    var containerHeight = jQuery('.c-editor__img--top').height() - jQuery('.c-nav').outerHeight() - 15;
    var containerWidth = Math.round(containerHeight / nbrContainerRatio);

    var maxContainerWidth = Math.round(configuratorHolder.width() * nbrBackgroundImageUsedPct) - parseInt(slideshowContent.css('padding-right')) - parseInt(slideshowContent.css('padding-left'));

    if (containerWidth > maxContainerWidth) {
        containerHeight = Math.round(containerHeight / containerWidth * maxContainerWidth);
        containerWidth = maxContainerWidth;
    }

    slideshowContent.width(containerWidth).height(containerHeight);

    var configuratorHeight = containerHeight;
    var configuratorWidth = Math.round(configuratorHeight * (arrWallDimensions[0] / arrWallDimensions[1]));

    nbrRescaleRatio = configuratorWidth / container.width();

    nbrRatio = containerWidth / nbrMaxWallWidth;
    topRatio = leftRatio = containerWidth / container.data('configurator-width');

    var destinationWidth = configuratorWidth;
    var destinationHeight = configuratorHeight;

    wall.width(destinationWidth).height(destinationHeight).show();
    container.width(destinationWidth).height(destinationHeight);

    // show wall width after configurator width and height has been calculated
    jQuery('.c-editor__configurator .configurator-wall-width').show();

    var totalWidth = 0;
    var totalHeight = 0;
    var minLeft = destinationWidth;
    var blnRemoveAll = false;

    items.each(function (index) {
        var el = jQuery(this);
        el.css({
            'left': Math.round(parseInt(el.css('left')) * leftRatio),
            'top': Math.round(parseInt(el.css('top')) * topRatio),
        });
        var img = el.find('img');
        var imgWidth = Math.round(img.width() * nbrRatio);
        var imgHeight = Math.round(img.height() * nbrRatio);
        img.width(imgWidth).height(imgHeight).data('width', imgWidth).data('height', imgHeight);
        minLeft = Math.min(minLeft, el.position().left);
    });

    items.each(function (index) {
        var el = jQuery(this);

        var itemRight = el.position().left - minLeft + el.outerWidth();
        if (itemRight > destinationWidth) {
            /*
            el.remove();
            items[index].remove();
            */
            blnRemoveAll = true;
            return false;
        } else {
            totalWidth = Math.max(totalWidth, itemRight);
        }

        var itemBottom = el.position().top + el.outerHeight();
        totalHeight = Math.max(totalHeight, itemBottom);
    });

    /*
    // rescaling is taken care of in the add_item() function now
    addItems.each(function (index) {
        var img = jQuery(this);
        var imgWidth = Math.round(img.data('original-width') * nbrRatio);
        var imgHeight = Math.round(img.data('original-height') * nbrRatio);
        img.data('width', imgWidth).data('height', imgHeight);
    });
    */

    if (blnRemoveAll) {
        items.each(function (index) {
            jQuery(this).remove();
            items[index].remove();
        });
        jQuery('.slideshow-section .slideshow-content .img-holder .wall .loading').remove();
    } else {
        var left = Math.round((destinationWidth - totalWidth) / 2);
        var top = Math.round((destinationHeight - totalHeight) / 2);

        items.each(function () {
            var el = jQuery(this);

            el.css({'left': el.position().left - minLeft + left, 'visibility': 'visible'});
        });
    }
}

function rescale_all() {
    var configuratorHolder = jQuery('.c-editor__configurator');
    var slideshowSection = jQuery('.c-editor__configurator .slideshow-section');
    var slideshowContent = jQuery('.c-editor__configurator .slideshow-content');
    var wall = jQuery('.c-editor__configurator .wall');
    var arrWallDimensions = [ wall.width(), wall.height() ];
    var container = jQuery(destinationSelector);
    var items = jQuery(itemSelector);
    //var addItems = jQuery('.slideshow-aside img');
    var addItems = jQuery('.c-editor__menu .c-editor__products .c-editor__product .c-editor__product-img');

    // slideshow section max height is area between nav-bar (logo) and floor - 15px for extra spacing between the configurator and the header
    var containerHeight = jQuery('.c-editor__img--top').height() - jQuery('.c-nav').outerHeight() - 15;
    var containerWidth = Math.round(containerHeight / nbrContainerRatio);

    var maxContainerWidth = Math.round(configuratorHolder.width() * nbrBackgroundImageUsedPct) - parseInt(slideshowContent.css('padding-right')) - parseInt(slideshowContent.css('padding-left'));

    if (containerWidth > maxContainerWidth) {
        containerHeight = Math.round(containerHeight / containerWidth * maxContainerWidth);
        containerWidth = maxContainerWidth;
    }

    slideshowContent.width(containerWidth).height(containerHeight);

    var configuratorHeight = containerHeight;
    var configuratorWidth = Math.round(configuratorHeight * (arrWallDimensions[0] / arrWallDimensions[1]));

    nbrRescaleRatio = configuratorWidth / container.width();

    nbrRatio = containerWidth / nbrMaxWallWidth;

    var destinationWidth = configuratorWidth;
    var destinationHeight = configuratorHeight;

    wall.width(destinationWidth).height(destinationHeight);
    container.width(destinationWidth).height(destinationHeight);

    items.each(function (index) {
        var el = jQuery(this);
        el.css({
            'left': Math.round(parseInt(el.css('left')) * nbrRescaleRatio),
            'top': Math.round(parseInt(el.css('top')) * nbrRescaleRatio),
        });
        var imgs = el.find('img');
        imgs.each(function() {
            var img = jQuery(this);
            var imgWidth = Math.round(img.width() * nbrRescaleRatio);
            if (img.data('type-element') === 'griplist') {
                if (imgWidth > img.siblings(':first-child').width()) {
                    imgWidth = img.siblings(':first-child').width();
                }
                imgHeight = img.attr('height');
            } else {
                var imgHeight = Math.round(img.height() * nbrRescaleRatio);
            }
            img.width(imgWidth).height(imgHeight).data('width', imgWidth).data('height', imgHeight);
            if (jQuery.inArray(img.data('type-element'), [ 'griplist', 'grip']) !== -1) {
                if (img.data('position-from') === 'top') {
                    img.css('top', Math.round(parseInt(img.css('top')) * nbrRescaleRatio));
                } else if (img.data('position-from') === 'bottom') {
                    img.css('bottom', Math.round(parseInt(img.css('bottom')) * nbrRescaleRatio));
                }
                img.data('3d-position', Math.round(parseInt(img.data('3d-position')) * nbrRescaleRatio));
            } else {
                if (img.css('top') !== 'auto') {
                    img.css('top', Math.round(parseInt(img.css('top')) * nbrRescaleRatio));
                }
            }
            if (img.css('left') !== 'auto') {
                img.css('left', Math.round(parseInt(img.css('left')) * nbrRescaleRatio));
            }
        });
    });

    /*
    // rescaling is taken care of in the add_item() function now
    addItems.each(function (index) {
        var img = jQuery(this);
        var imgWidth = Math.round(img.data('original-width')  * nbrRatio);
        var imgHeight = Math.round(img.data('original-height') * nbrRatio);
        img.data('width', imgWidth).data('height', imgHeight);
    });
    */

    jQuery('.chosen-container').hide().each(function (i, el) {
        var container = jQuery(el);
        container.width(container.closest('.options-list').width());
        container.show();
    });

    calculate_configuration_dimensions();
}

function get_image(elements_data, elements, showAlert) {
	if (!jQuery.isArray(elements_data)) elements_data = [ elements_data ];
	if (!jQuery.isArray(elements)) elements = [ elements ];
	if (showAlert == null) showAlert = true;
	
	jQuery.each(elements, function(index, element) {
		element.off('load');
		if (selected_color != undefined) elements_data[index].selected_color = selected_color;
		if (selected_grip != undefined) elements_data[index].selected_grip = selected_grip;
		if (selected_shelf != undefined) elements_data[index].selected_shelf = selected_shelf;
		if (selected_linksku != undefined) elements_data[index].selected_linksku = selected_linksku;
	});

	jQuery.ajax({
		url: "/includes/get_image.php",
		data: { 
			elements_data: elements_data,
            nbrRatio: nbrRatio,
            nbrRescaleRatio: nbrRescaleRatio
		},
		type: 'POST',
		dataType: 'json',
		cache: false,
		success: function(data) {
			if (data.status) {
				jQuery.each(data.elements, function(index, element) {
					if (element.status) {
						var el = elements[index];
                        el.parent().find('img:not(.element)').remove();
						// make sure the image is not cached or the onload event will not work in safari
						// so we add the timestamp to the image src
						el.attr('src', element.src + '?_=' + new Date().getTime());

                        el.data('sku', element.sku);
                        el.data('3d', element.filename_3d + (element.extension_3d !== '' ? element.extension_3d : ''));

						if (element.selected_color != undefined) {
							selected_color = element.selected_color; 
							el.data('selected_color', element.selected_color);
						} else {
							el.data('selected_color', '');
						}
						if (element.selected_grip != undefined) {
							selected_grip = element.selected_grip;
							el.data('selected_grip', element.selected_grip);
						} else {
							el.data('selected_grip', '');
						}
						if (element.selected_shelf != undefined) {
							selected_shelf = element.selected_shelf;
							el.data('selected_shelf', element.selected_shelf);
						} else {
							el.data('selected_shelf', '');
						}
						if (element.selected_linksku != undefined) {
							selected_linksku = element.selected_linksku;
							el.data('selected_linksku', element.selected_linksku);
						} else {
							el.data('selected_linksku', '');
						}
						if (element.selected_customwidth != undefined) {
                            el.data('selected_customwidth', element.selected_customwidth);
						}
                        if (element.selected_position_wk_1 != undefined) {
                            el.data('selected_position_wk_1', element.selected_position_wk_1);
						} else {
                            el.data('selected_position_wk_1', '');
						}
                        if (element.selected_position_wk_2 != undefined) {
                            el.data('selected_position_wk_2', element.selected_position_wk_2);
                        } else {
                            el.data('selected_position_wk_2', '');
						}
                        if (element.position_faucet != undefined) {
                        	var position_faucet = [];
                        	jQuery.each(element.position_faucet, function (index, faucet) {
                        		position_faucet[index] = faucet['position'];
							});
                        	el.data('position_faucet', position_faucet);
						}
                        el.data('element-data', element);
						if (jQuery.inArray(element.kind, arrNoShadow) != -1) el.addClass('no-shadow');

                    } else {
						if (showAlert) alert('Missing image: ' + element.element); 
					}
				});
			}
		}
	});
}

function array_search(strValue, strKey, arrElements){
	var rval = false;
    jQuery.each(arrElements, function(index, arrElement) {
        if (arrElement[strKey] === strValue) {
			rval = true;
            return false;
        }
    });
	return rval;
}

jQuery.fn.isolatedScroll = function() {
	this.bind('mousewheel DOMMouseScroll', function (e) {
		var delta = e.wheelDelta || (e.originalEvent && e.originalEvent.wheelDelta) || -e.detail,
			bottomOverflow = this.scrollTop + jQuery(this).outerHeight() - this.scrollHeight >= 0,
			topOverflow = this.scrollTop <= 0;
			
		if ((delta < 0 && bottomOverflow) || (delta > 0 && topOverflow)) {
			e.preventDefault();
		}
	});
	return this;
};				

/*
// slick init
function init_slick_carousel() {
    setTimeout(function() {
        jQuery('.preview-gallery').slick(previewGalleryConfiguration);
		jQuery('.vertical-gallery').css({'visibility':'visible'});
    }, 200);
}
*/

// accordion menu init
function init_accordion() {
    jQuery('ul.accordion').slideAccordion({
        opener: 'a.opener',
        slider: '.accordion-slide',
        animSpeed: 300
    });
}

function is_touch_device() {
	return (('ontouchstart' in window)	
		|| (navigator.MaxTouchPoints > 0)
		|| (navigator.msMaxTouchPoints > 0));
}
 
function post_to_api(data) {
	if (jQuery.inArray(data.step, [ 'configure', 'quotation', 'order' ]) != -1) {
		var formData = {
			'step': data.step,
			'configID': data.configID,
		}
		if (data.orderID != null) {
			formData.orderID = data.orderID;
		}

		jQuery.ajax({
			url: '/includes/post_to_api.php',
			method: 'POST',
			data: formData,
			dataType: 'json',
			cache: false
		});
	}
}

function format_ral_current_option(optionCode) {
	var currentOption = jQuery('#' + optionCode + ' option:selected');
	jQuery('div#' + optionCode + '_chosen .chosen-single span').html('<div class="ralColorOption"><span class="' + currentOption.data('class') + '">' + currentOption.text() + '</span></div>');
}

function format_ral_options(optionCode) {
	jQuery('div#' + optionCode + '_chosen .chosen-results li').each(function(i, el) {
		el = jQuery(el);
		var currentOption = jQuery('#' + optionCode).find('option').eq(el.data('option-array-index'));
		el.html('<div class="ralColorOption"><span class="' + currentOption.data('class') + '">' + currentOption.text() + '</span></div>');
	});
}

function copyToClipboard(input) {
    var r = document.createRange();
    r.selectNode(document.getElementById(input));
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
}

function storeBackground(color, type) {
    jQuery.ajax({
        url: '/includes/store_background.php',
        type: 'POST',
        dataType: 'json',
        data: {
            'color': color,
            'type': type
        },
        success: function(data) {
            if(data?.floorColor) {
                sessionStorage.setItem("floorTexture", data.floorColor);
                sessionStorage.setItem("floorTexture", data.floorColor.ID);
            }
            if(data?.wallColor) {
                sessionStorage.setItem("wallTexture", data.wallColor);
                sessionStorage.setItem("wallTexture", data.wallColor.ID);
            }
       }
    });
}

$( function() {
    $.widget( "custom.combobox", {
        _create: function() {
            this.wrapper = $( "<span>" )
                .addClass( "custom-combobox" )
                .insertAfter( this.element );

            this.element.hide();
            this._createAutocomplete();
            this._createShowAllButton();
        },

        _createAutocomplete: function() {
            var selected = this.element.children( ":selected" ),
                value = selected.val() ? selected.text() : "";

            this.input = $( "<input>" )
                .appendTo( this.wrapper )
                .val( value )
                .attr( "title", "" )
                .attr( "type", "text" )
                .attr( "name", "combobox-search[]" )
                .addClass( "custom-combobox-input" )
                .autocomplete({
                    delay: 0,
                    minLength: 0,
                    source: this._source.bind( this )
                })
                .tooltip({
                    classes: {
                        "ui-tooltip": "ui-state-highlight"
                    }
                });

            this._on( this.input, {
                autocompleteselect: function( event, ui ) {
                    ui.item.option.selected = true;
                    this._trigger( "select", event, {
                        item: ui.item.option
                    });
                },

                autocompletechange: "_removeIfInvalid"
            });
        },

        _createShowAllButton: function() {
            var input = this.input,
                wasOpen = false;

            $( "<a>" )
                .attr( "tabIndex", -1 )
                .appendTo( this.wrapper )
                .button({
                    icons: {
                        primary: "ui-icon-triangle-1-s"
                    },
                    text: false
                })
                .removeClass( "ui-corner-all" )
                .addClass( "custom-combobox-toggle ui-corner-right" )
                .on( "mousedown", function() {
                    wasOpen = input.autocomplete( "widget" ).is( ":visible" );
                })
                .on( "click", function() {
                    input.trigger( "focus" );

                    // Close if already visible
                    if ( wasOpen ) {
                        return;
                    }

                    // Pass empty string as value to search for, displaying all results
                    input.autocomplete( "search", "" );
                });
        },

        _source: function( request, response ) {
            var matcher = new RegExp( $.ui.autocomplete.escapeRegex(request.term), "i" );
            response( this.element.children( "option" ).map(function() {
                var text = $( this ).text();
                if ( this.value && ( !request.term || matcher.test(text) ) )
                    return {
                        label: text,
                        value: text,
                        option: this
                    };
            }) );
        },

        _removeIfInvalid: function( event, ui ) {

            // Selected an item, nothing to do
            if ( ui.item ) {
                this.element.valid();
                return;
            }

            // Search for a match (case-insensitive)
            var value = this.input.val(),
                valueLowerCase = value.toLowerCase(),
                valid = false;
            this.element.children( "option" ).each(function() {
                if ( $( this ).text().toLowerCase() === valueLowerCase ) {
                    this.selected = valid = true;
                    return false;
                }
            });

            // Found a match, nothing to do
            if ( valid ) {
                return;
            }

            // Remove invalid value
            this.input
                .val( "" );
            this.element.val( "" );
            this.input.autocomplete( "instance" ).term = "";
        },

        _destroy: function() {
            this.wrapper.remove();
            this.element.show();
        }
    });

    $( ".autocomplete-combobox" ).combobox();
} );

jQuery(window).on('beforeprint', function() { jQuery('.c-mobile').addClass('keepHidden') });
jQuery(window).on('afterprint', function() { jQuery('.c-mobile').removeClass('keepHidden') });

jQuery(window).load(function() {
    if (jQuery('#main.configure').length) {
        //update_element_selector(jQuery("#main.configure #kinds").val());

        set_containment_container_dimensions();
        position_initial_items();

        var elements = [];
        var elements_data = [];
        jQuery(itemSelector).each(function() {
            elements.push(jQuery(this).find('img'));
            elements_data.push(jQuery(this).find('img').data());

        });

        get_image(elements_data, elements, false);

        numberOfImagesToLoad = jQuery(itemSelector).length;
        // if we have no images to load, remove the loading icon
        if (numberOfImagesToLoad <= 0) jQuery('.slideshow-section .slideshow-content .img-holder .wall .loading').remove();

        jQuery(itemSelector).each(function() {
            jQuery(this).on('mousedown touch', function(event) {
                select_item(jQuery(this));
            });

            jQuery(this).data('maxVerticalMove', nbrMaxVerticalMove);

            jQuery(this).find('img').one('load', function() {
                show_element_attributes(jQuery(this));

                var parent = jQuery(this).parent();

                var containment = calculate_item_containment(parent, parent.data('position'));
                parent.data('containment', containment);

                make_item_draggable(parent);

                numberOfImagesToLoad--;
                // if all images are loaded, remove the loading icon
                if (numberOfImagesToLoad <= 0) {
                    jQuery('.slideshow-section .slideshow-content .img-holder .wall .loading').remove();

                    // calculate configuration_dimensions
                    calculate_configuration_dimensions();

                    // initialize configuration measurements display based on user preferences (hidden or not)
                    if (sessionStorage.getItem('configuration_measurements_hidden')) {
                        jQuery('#main.configure .js-configuration-measurements').removeClass('measurements-visible');
                        jQuery('#main.configure .btn-measurements').removeClass('is-active');
                    } else {
                        jQuery('#main.configure .js-configuration-measurements').addClass('measurements-visible');
                        jQuery('#main.configure .btn-measurements').addClass('is-active');
                    }

                }
            });
        });

    }
});